export const zh = {
  translation: {
    // Nav
    nav: {
      dashboard: "仪表盘",
      orders: "订单管理",
      transactions: "交易记录",
      refunds: "退款管理",
      menu: "菜单管理",
      categories: "菜单分类",
      vouchers: "优惠券",
      bundles: "套餐管理",
      stalls: "档口管理",
      stallApplications: "档口申请",
      paymentMethods: "支付方式",
      deliveryProviders: "配送服务商",
      smsProviders: "短信服务商",
      banners: "促销横幅",
      adminAccounts: "管理员账号",
      staff: "员工管理",
      customers: "顾客管理",
      reports: "报表分析",
      activity: "操作日志",
      flags: "功能开关",
      pricingRules: "定价规则",
      hours: "营业时间",
      legalContent: "法律内容",
      settings: "系统设置",
      brandTitle: "茶室管理后台",
      brandSubtitle: "指挥中心",
    },
    // Common
    notFound: { title: "页面不存在", desc: "这个地址没有对应的页面，可能是链接过期或输入有误。", toDashboard: "回到仪表盘", goBack: "返回上一页" },
    common: {
      openMenu: "打开导航菜单",
      close: "关闭",
      previousPage: "上一页",
      nextPage: "下一页",
      save: "保存",
      cancel: "取消",
      confirm: "确认",
      delete: "删除",
      edit: "编辑",
      create: "新建",
      refresh: "刷新",
      loading: "加载中…",
      noData: "暂无数据",
      total: "共 {{count}} 条",
      success: "操作成功",
      failed: "操作失败，请重试",
      signOut: "退出登录",
      confirmDelete: "确认删除此项？",
      selectStall: "选择档口",
      yes: "是",
      no: "否",
      back: "返回",
      stall: "档口",
      saved: "已保存",
      search: "搜索订单（单号 / 顾客姓名 / 手机号），按回车查询…",
      exportCsv: "导出 CSV",
      clearFilters: "清除筛选",
      guest: "访客",
      connectionTestOk: "{{message}}",
      connectionTestOkWithLatency: "{{message}}（{{ms}} 毫秒）",
      connectionTestFailed: "{{message}}",
      system: "系统",
      switchLangEn: "English",
      switchLangZh: "中文",
      language: "语言",
      swipeForMore: "左滑查看更多 →",
      all: "全部",
      active: "启用",
      disabled: "已停用",
      savePct: "省 RM {{amount}}（{{pct}}% 折扣）",
      pickupOnly: "仅自取",
      deliveryOnly: "仅外卖",
      pickupAndDelivery: "自取与外卖",
      noExpiry: "无期限",
      saveChanges: "保存更改",
      tablePageRange: "第 {{start}}–{{end}} 条，共 {{total}} 条",
    },
    // Auth
    auth: {
      brandName: "KawKaw Kopitiam",
      login: "管理员登录",
      email: "邮箱",
      password: "密码",
      loginBtn: "登录",
      loginFailed: "邮箱或密码错误",
      loginErrorDetail: "邮箱或密码无效，请重试。",
      brandTagline: "管理后台 — 在一处管理门店、员工、菜单与订单。",
      featureOrder: "实时订单管理",
      featureStaff: "员工与权限管理",
      featureReports: "销售报表与分析",
      featureSettings: "门店设置与品牌",
      copyright: "© 2026 KawKaw Kopitiam",
      welcomeBack: "欢迎回来",
      signInSubtitle: "登录管理员账号以继续",
      emailLabel: "邮箱地址",
      passwordLabel: "密码",
      emailRequired: "请输入邮箱",
      emailInvalid: "请输入有效邮箱",
      passwordRequired: "请输入密码",
      passwordPlaceholder: "请输入密码",
      signInBtn: "登录 →",
      demoCredentials: "🔑 演示账号",
      demoSuperLine: "{{email}} / {{password}} — 超级管理员",
      demoAdminLine: "{{email}} / {{password}} — 管理员",
      emailPlaceholder: "admin@kawkaw.my",
    },
    // Orders
    orders: {
      title: "订单管理",
      colOrderId: "订单编号",
      colCustomer: "顾客",
      colTotal: "总金额",
      colStatus: "状态",
      colPayment: "支付方式",
      colPlacedAt: "下单时间",
      searchPlaceholder: "搜索订单编号 / 顾客",
filteredByCustomer: "已按顾客筛选",
      filterStatus: "筛选状态",
      drawerStatus: "状态",
      drawerTotal: "总金额",
      drawerPayment: "支付方式",
      drawerCustomer: "顾客",
      drawerPlaced: "下单时间",
      drawerNotes: "备注",
      drawerItems: "餐品",
      drawerSubtotal: "小计",
      drawerDiscount: "折扣",
      drawerSST: "消费税",
      drawerDelivery: "送餐费",
      status: {
        new: "新订单",
        pending: "待处理",
        confirmed: "已确认",
        preparing: "备餐中",
        ready: "已就绪",
        completed: "已完成",
        cancelled: "已取消",
        delivered: "已送达",
        out_for_delivery: "配送中",
        in_transit: "运送中",
      },
      type: {
        pickup: "自取",
        delivery: "外卖",
      },
      cancelSuccess: "订单已取消",
      cancelFailed: "取消订单失败",
      cancelModalTitle: "取消订单",
      cancelConfirm: "取消订单",
      cancelHint:
        "取消后订单将标记为已取消并通知顾客。如有退款请至「退款管理」单独处理。",
      cancelReason: "原因（将记入操作日志）",
      cancelReasonPlaceholder: "例如：重复下单、顾客要求取消、缺货…",
      cancelOrderAction: "取消订单",
      filterAll: "全部",
      listHeading: "订单",
      liveFeedActive: "实时动态：{{count}} 单进行中",
      filterType: "类型：",
      typeDisabledWalkinHint: "堂食订单始终为自取，不会有外卖",
      colAmount: "金额",
      colOrderTime: "下单时间",
      colAction: "操作",
      menuOverview: "概览",
      menuFullDetails: "完整详情",
      menuCancelOrder: "取消订单",
      actionMarkReady: "标记已就绪",
      actionPickedUp: "已取餐",
      actionOutForDelivery: "开始配送",
      actionDelivered: "已送达",
      actionMarkAsReady: "标记为已就绪",
      actionMarkDelivered: "标记已送达",
      drawerChannelDelivery: "外卖",
      drawerChannelPickup: "到店自取",
      drawerPaid: "已付款",
      drawerCancelReason: "取消原因",
      drawerUnpaid: "待支付",
      drawerPaymentFailed: "支付失败",
      drawerUnpaidBadge: "待支付",
      drawerPaymentFailedBadge: "支付失败",
      drawerCustomerDetails: "顾客信息",
      drawerDeliveryTime: "配送时间",
      drawerRider: "骑手",
      drawerLalamoveId: "Lalamove 单号",
      drawerTrack: "追踪链接",
      drawerProgress: "配送进度",
      lmAssigning: "正在找骑手",
      lmOnGoing: "骑手正前往取餐",
      lmPickedUp: "骑手已取餐，配送中",
      lmCompleted: "已送达",
      lmFailed: "配送失败",
      drawerPickupTime: "取餐时间",
      drawerOrderItemsCount: "订单商品（{{count}}）",
      drawerTotalAmount: "合计金额",
      drawerPaymentMethod: "支付方式",
      drawerPaidBadge: "已付",
      drawerAsap: "尽快",
      updateStatusFailed: "更新订单状态失败",
      statusTabNew: "新订单",
      statusTabPreparing: "备餐中",
      statusTabReady: "已就绪",
      statusTabOutForDelivery: "配送中",
      statusTabInTransit: "运送途中",
      statusTabDelivered: "已送达",
      statusTabCompleted: "已完成",
      statusTabCancelled: "已取消",
      filterAllStalls: "全部档口",
      discountWithCode: "优惠（{{code}}）",
      voucherFallback: "优惠券",
      sstWithRate: "消费税（{{rate}}%）",
    },
    refundDetail: {
      notFound: "未找到该退款记录。",
      back: "返回",
      title: "退款详情",
      status: {
        success: "已完成",
        pending: "处理中",
        rejected: "已拒绝",
        failed: "失败",
      },
      typeFull: "全额退款",
      typePartial: "部分退款",
      timelineCreated: "退款已创建",
      timelineProcessing: "处理中",
      timelineCompleted: "退款已完成",
      timelineRejected: "退款已拒绝",
      timelineFailed: "网关退款失败",
      staffSystem: "系统",
      staffAdmin: "管理员",
      staffGateway: "Fiuu 网关",
      gatewayFailureTitle: "网关退款失败",
      autoRefundBadge: "通过 Fiuu 自动退款",
      gatewayRefundIdLabel: "网关退款编号",
      refundIdLabel: "退款编号",
      refundAmount: "退款金额",
      amountReclaimedLabel: "退款金额",
      refundType: "退款类型",
      createdTime: "创建时间",
      requestSource: "请求来源",
      requestSourcePos: "POS 终端",
      customerInfo: "顾客信息",
      guest: "访客",
      noCustomer: "无顾客信息",
      phone: "电话",
      email: "邮箱",
      transactionInfo: "交易信息",
      viewTransaction: "查看交易 →",
      transactionId: "交易编号",
      orderId: "订单编号",
      paymentMethod: "支付方式",
      totalPaid: "实付金额",
      refundReason: "退款原因",
      internalNote: "内部备注",
      transferDetails: "转账详情",
      method: "方式",
      time: "时间",
      merchantNoteUpper: "商家备注",
      processTimeline: "处理时间线",
      dash: "—",
    },
    orderDetail: {
      invalidId: "无效的订单编号。",
      notFound: "未找到订单。",
      back: "返回",
      statusMessageLabel: "状态说明",
      orderPrefix: "订单",
      paid: "已付款",
      asap: "尽快",
      customer: "顾客",
      customerShortId: "顾客 {{id}}",
      pickupTime: "取餐时间",
      customerWillArrive: "顾客将到店取餐",
      cancelledTime: "订单取消时间",
      orderCancelledAt: "订单已取消",
      deliveryAddress: "配送地址",
      rider: "骑手",
      riderCancelled: "订单已取消，不再派送",
      riderDelivered: "已送达",
      findingRider: "正在寻找骑手...",
      deliveryFailed: "配送失败 — 需要人工处理",
      resubmitLalamove: "重新提交至 Lalamove",
      resubmitLalamoveTitle: "重新提交至 Lalamove",
      resubmitLalamoveDesc: "这将重新获取 Lalamove 报价并为该订单派送新的骑手。",
      resubmitLalamoveConfirm: "重新提交",
      resubmitLalamoveSuccess: "已重新提交至 Lalamove — 新骑手派送请求已发送",
      resubmitLalamoveFailed: "重新提交至 Lalamove 失败",
      pickupTimeRider: "档口备餐完成时间",
      riderWillArrive: "餐点已就绪，等待骑手取餐",
      riderHeadingToShop: "骑手正在前往餐厅取餐",
      etaArrive: "预计约 {{time}} 送达（估算）",
      distanceNotRecorded: "配送距离：未记录（下单时店铺未设置坐标）",
    riderPlate: "车牌",
      deliveredAtLabel: "已送达时间",
      deliveredNote: "订单已送达",
      deliverConfirmTitle: "确认已送达？",
      deliverConfirmDesc: "标记已送达后，订单将无法取消，顾客会收到「已送达」通知。",
      deliverForcePrompt: "骑手还没有取餐。如果确实已经送到，请输入原因（至少 3 个字）：",
      trackRider: "追踪骑手 →",
      specialNote: "特殊备注",
      rating: "顾客评分",
      orderItems: "订单商品",
      itemsTotal: "共 {{count}} 件",
      basePriceMarkup: "原价 RM {{base}} + 加价 RM {{markup}}",
      addonCostMarkup: "加料 RM {{cost}} + 加料加价 RM {{markup}}",
      stallPrefix: "档口",
      basePriceTotal: "原价合计",
      markupTotal: "加价合计",
      addonCostTotal: "加料成本合计",
      addonMarkupTotal: "加料加价合计",
      subtotal: "小计",
      discount: "优惠",
      deliveryFee: "配送费",
      sstPercent: "消费税（{{rate}}%）",
      sstIncludedRow: "SST（已含在价格内）",
      total: "合计",
      customerPaidAmount: "顾客实付金额",
      refundHistory: "退款记录",
      noRefunds: "该订单暂无退款记录。",
      createRefund: "发起退款",
      transactionDetails: "交易详情",
      method: "方式",
      status: "状态",
      paidUpper: "已支付",
      transactionId: "交易编号",
      viewTransaction: "查看交易",
      noTxnRecord: "无交易记录",
      orderJourney: "订单进度",
      cancelOrder: "取消订单",
      printReceipt: "打印小票",
      markAsReady: "标记为已就绪",
      pickedUp: "已取餐",
      outForDelivery: "开始配送",
      markDelivered: "标记已送达",
      cancelModalTitle: "取消订单",
      cancelOk: "取消订单",
      reasonLabel: "取消原因",
      reasonPlaceholder: "例如：顾客要求取消",
      reasonRequired: "请填写原因（至少 3 个字符）",
      statusUpdated: "订单状态已更新",
      updateStatusFailed: "更新状态失败",
      cancelSuccess: "订单已取消",
      cancelFailed: "取消订单失败",
      refundFormTitle: "退款表单",
      refundOrderSummary: "支付摘要",
      refundPaidAmount: "已支付金额",
      refundMaxAmount: "最多可退：RM {{amount}}",
      refundType: "退款类型",
      refundAmount: "退款金额",
      refundMethod: "退款方式",
      refundReason: "退款原因",
      refundReasonPlaceholder: "例如：POS 取消订单但顾客已付款",
      submitRefund: "提交退款",
      refundCreated: "退款申请已建立",
      refundCreateFailed: "建立退款失败",
      refundNoPaidTxn: "该订单没有成功付款交易。",
      refundNoPaymentTitle: "付款尚未完成",
      refundNoPaymentDesc: "顾客成功付款后，才可以为此订单发起退款。",
      refundAmountInvalid: "请输入有效退款金额。",
      refundReasonRequired: "请填写退款原因。",
      payment: {
        visa: "Visa/万事达",
        fpx: "FPX 网银",
        grabpay: "GrabPay",
        cash: "现金",
        ewallet: "电子钱包",
        tng: "Touch 'n Go",
        boost: "Boost",
      },
      statusMsg: {
        new: "等待档口接单",
        preparing: "档口正在备餐",
        readyPickup: "餐品已就绪，等待顾客取餐",
        readyDelivery: "餐品已就绪，等待分配骑手",
        outForDelivery: "骑手正在前往取餐",
        pickedUp: "骑手已取餐，正在送往顾客",
        deliveryIssue: "配送遇到问题 — 请查看下方骑手状态",
        inTransit: "订单配送途中",
        delivered: "订单已送达顾客",
        completedPickup: "顾客已取餐",
        completedDelivery: "订单已完成",
        cancelled: "订单已取消",
      },
      journey: {
        orderCreated: "订单已创建",
        accepted: "已接单",
        preparing: "备餐中",
        ready: "已就绪",
        waitingPickup: "等待取餐",
        riderAssigned: "已分配骑手",
        riderArrived: "骑手已到店",
        outForDelivery: "配送中",
        delivered: "已送达",
        pickedUp: "已取餐",
        cancelledBy: "{{name}} 已取消订单",
        unknownCanceller: "员工",
      },
      journeyCurrent: "（当前）",
      journeyPending: "待处理",
      journeyTimeCurrent: "{{time}}（当前）",
      refundRowStatus: {
        success: "已完成",
        pending: "待处理",
        failed: "失败",
      },
      txnPending: "待支付",
    },
    transactionDetail: {
      notFound: "未找到交易记录。",
      breadcrumb: "交易详情",
      totalAmount: "总金额",
      paymentMethod: "支付方式",
      colProvider: "渠道",
      colReferenceId: "参考号",
      colAuthorization: "授权状态",
      merchantReference: "商户参考号",
      success: "成功",
      paymentBreakdown: "支付明细",
      subtotal: "小计",
      deliveryFee: "配送费",
      taxSst: "税费（消费税 {{rate}}%）",
      discount: "优惠",
      finalPaidAmount: "实付金额",
      partialRefundIssued: "已发起部分退款",
      fullRefundIssued: "已发起全额退款",
      reason: "原因",
      method: "方式",
      viaPrefix: "通过 {{method}}",
      merchantInternalNote: "商家内部备注",
      customerInfo: "顾客信息",
      noCustomer: "无顾客信息",
      viewOrderDetails: "查看订单详情 →",
      transactionHistory: "交易历史",
      issueRefund: "发起退款",
      downloadReceipt: "下载小票",
      orderIdLabel: "订单编号",
      statusPaid: "已支付",
      statusPartialRefund: "部分退款",
      statusRefunded: "已退款",
      statusRefundPending: "退款处理中",
      statusPending: "待处理",
      statusFailed: "失败",
      timelinePaid: "支付完成（成功）",
      timelineInitiated: "支付已发起",
      timelineRefundInitiated: "退款已发起",
      timelineRefundApproved: "退款已批准",
      timelineRefundRejected: "退款已拒绝",
      timelineOrderCancelled: "管理员取消订单",
      refundMetaDesc: "类型：{{type}}，金额：RM {{amount}}，方式：{{method}}",
      refundTypePartial: "部分",
      refundTypeFull: "全额",
      timelineNote: "备注",
      timelineTransferTime: "转账时间",
      timelineTransferMethod: "转账方式",
      checkoutBy: "{{name}} 结账",
      authCode: "授权码：{{reference}}",
      authSuccess: "成功",
    },
    staff: {
      stallRequired: "档口员工必须选择所属档口",
      noSessions: "这段时间没有登录记录",
      lastLoginToday: "今天，{{time}}",
      lastLoginYesterday: "昨天",
      lastLoginDaysAgo: "{{count}} 天前",
      none: "—",
      historyDate: "日期",
      historyTablet: "平板",
      historyLogin: "登录",
      historyLogout: "登出",
      historyDuration: "时长",
      historyStatus: "状态",
      online: "在线",
      completed: "已完成",
      totalSessions: "总会话数",
      avgDuration: "平均时长",
      dailyAverage: "日均",
      lastSeen: "最后在线",
      exportCsv: "导出 CSV",
      close: "关闭",
      loginHistoryTitle: "登录历史",
      roleAdmin: "管理员",
      roleStaffLabel: "员工",
      saveChanges: "保存更改",
      saveStaff: "保存员工 →",
      editStaff: "编辑员工",
      addStaff: "添加员工",
      personalInfo: "个人信息",
      fullName: "姓名",
      placeholderFullName: "例如：伟康",
      placeholderPhone: "+60 12–345 6789",
      fullNameRequired: "请输入姓名",
      phoneNumber: "手机号",
      phoneInvalid: "请输入有效的马来西亚手机号，例如 0123456789",
      phoneInUse: "该手机号已被使用",
      emailInUse: "该邮箱已被使用",
      phoneRequired: "请输入手机号",
      roleAccess: "角色与权限",
      admin: "管理员",
      staff: "员工",
      posOperator: "POS 操作员",
      roleInfoAdmin: "可访问全部功能，含报表、菜单与员工管理。",
      roleInfoStall: "登录档口应用 — 仅可查看和管理所属档口的厨房订单队列。",
      roleInfoPos: "登录 POS 应用记录堂食销售并管理订单。不分配档口则为可查看所有档口的前台终端；分配单一档口则仅限该档口订单。",
      assignedTablet: "分配平板",
      assignedStallPos: "分配档口（可选）",
      notAssigned: "未分配",
      notAssignedAllStalls: "未分配（可查看所有档口）",
      loginPin: "登录 PIN",
      setupPin: "设置 PIN",
      confirmPin: "确认 PIN",
      pinRequired: "请输入 PIN",
      pinLen: "PIN 须为 4 位数字",
      pinNumeric: "PIN 仅可为数字",
      confirmPinRequired: "请再次确认 PIN",
      pinMismatch: "两次 PIN 不一致",
      pinHint: "员工将使用此 PIN 在平板登录。请确保唯一且保密。",
      updatedOk: "员工信息已更新",
      addedOk: "员工已添加",
      saveFailed: "保存失败，请重试。",
      cancel: "取消",
      resetPinTitle: "重置 PIN",
      resetPinBtn: "重置 PIN →",
      newPinSection: "新 PIN",
      newPin: "新 PIN",
      pinResetOk: "PIN 已重置",
      pinResetFailed: "重置 PIN 失败",
      resetPinHint: "新 PIN 立即生效，员工下次登录需使用新 PIN。",
      pinLenReset: "PIN 须为 4 位",
      numericOnly: "仅数字",
      managementTitle: "员工管理",
      pageSubtitle: "管理营运员工、岗位分配与登录权限。",
      addStaffBtn: "添加员工",
      periodToday: "今天",
      periodWeek: "本周",
      periodMonth: "本月",
      totalStaff: "员工总数",
      teamMembers: "团队成员",
      active: "在职",
      currentlyWorking: "在岗",
      inactive: "停用",
      offDuty: "离岗",
      searchPlaceholder: "搜索姓名或手机号…",
      allRoles: "全部角色",
      allStatus: "全部状态",
      activeStatus: "在职",
      inactiveStatus: "停用",
      colStaffDetails: "员工信息",
      colRole: "角色",
      colAssignedTablet: "分配平板",
      colStatus: "状态",
      colLastLogin: "最后登录",
      colActions: "操作",
      notAssignedTablet: "未分配",
      statusActive: "● 在职",
      statusInactive: "● 停用",
      edit: "编辑",
      loginHistory: "登录历史",
      resetPassword: "重置密码",
      removeStaff: "移除员工",
      removedOk: "已移除员工",
      removeFailed: "移除失败",
      showingCount: "显示 {{filtered}} / {{total}} 名员工",
      // Admin Accounts screen (/admins)
      adminAccountsTitle: "管理员账号",
      adminAccountsSubtitle: "管理后台登录账号、访问权限与启用状态",
      adminStatTotal: "管理员总数",
      adminStatActive: "已启用",
      adminStatInactive: "已停用",
      adminStatBadgeOverall: "全部账号",
      adminStatBadgeActive: "可正常登录",
      adminStatBadgeInactive: "暂停使用",
      adminDrawerSubtitleNew: "配置账号资料与可访问的功能",
      adminDrawerSubtitleEdit: "更新账号资料、密码与权限",
      addAdminBtn: "添加管理员",
      editAdmin: "编辑管理员",
      colEmail: "邮箱",
      emailRequired: "请输入有效邮箱",
      placeholderEmail: "example@kawkaw.my",
      passwordLabel: "密码",
      passwordPlaceholderCreate: "至少 8 位字符",
      passwordPlaceholderEdit: "留空以保持密码不变",
      passwordRequired: "请输入密码",
      passwordMinLength: "密码至少需要 8 位字符",
      permissionsTitle: "权限",
      permissionsHint: "勾选此管理员可访问的功能模块。",
      colPermissions: "权限",
      allPermissions: "全部权限",
      noPermissions: "无权限",
      morePermissions: "+{{count}} 项",
      superadminBadge: "超级管理员",
      superadminLockedHint: "超级管理员拥有全部权限，角色与权限不可编辑。",
      todayWeekMonthToday: "今天",
      todayWeekMonthWeek: "本周",
      todayWeekMonthMonth: "本月",
      editTitle: "编辑员工",
      addTitle: "添加员工",
      colName: "姓名",
      colPhone: "电话",
      colStall: "档口",
      colCreated: "创建时间",
      tooltipEdit: "编辑员工",
      tooltipResetPin: "重置 PIN",
      formInitialPin: "初始 PIN（4位数字）",
      formPinLengthMsg: "PIN 必须恰好为 4 位数字",
      formAssignedStall: "分配档口（适用于档口员工）",
      formNewPin: "新 PIN",
      formConfirmPin: "确认 PIN",
      pinDigitsMsg: "4–6 位数字",
      pinResetSuccess: "PIN 已重置 — 临时 PIN: {{pin}}（请告知员工）",
      pinResetSuccessSimple: "PIN 重置成功",
      createSuccess: "员工已创建",
      updateSuccess: "员工已更新",
    },
    customers: {
      managementTitle: "顾客管理",
      pageSubtitle: "查看和管理 App 端顾客 — 资料、地址、订单与访问权限。",
      searchPlaceholder: "搜索姓名、手机号或邮箱…",
      allStatus: "全部状态",
      activeStatus: "启用",
      inactiveStatus: "已停用",
      colName: "顾客",
      colContact: "联系方式",
      colStatus: "状态",
      colOrders: "订单数",
      colRegistered: "注册时间",
      colActions: "操作",
      statusActive: "启用",
      statusInactive: "已停用",
      viewDetail: "查看详情",
      detailTitle: "顾客详情",
      close: "关闭",
      profile: "资料",
      fullName: "姓名",
      email: "邮箱",
      phone: "手机号",
      registeredVia: "注册方式",
      registeredOn: "注册时间",
      save: "保存",
      saveSuccess: "顾客资料已更新",
      saveFailed: "更新顾客资料失败",
      accountStatus: "账号状态",
      enabled: "启用",
      disabled: "已停用",
      enableConfirmTitle: "启用该顾客账号？",
      disableConfirmTitle: "停用该顾客账号？",
      disableConfirmDesc: "停用后该顾客会立即退出登录，并且无法再登录，直到重新启用。",
      disableAction: "停用",
      statusUpdateSuccess: "账号状态已更新",
      statusUpdateFailed: "更新账号状态失败",
      addresses: "收货地址",
      noAddresses: "暂无收货地址",
      defaultAddress: "默认",
      recentOrders: "最近订单",
      noOrders: "暂无订单",
      viewAllOrders: "查看全部订单 →",
      resetPassword: "重置密码",
      resetPasswordConfirmTitle: "重置该顾客的密码？",
      resetPasswordConfirmDesc: "系统将生成一个临时密码，顾客可立即用其登录，但下次登录时必须自行设置新密码。",
      resetPasswordFailed: "重置密码失败",
      tempPasswordTitle: "临时密码已生成",
      tempPasswordDesc: "请将以下临时密码提供给顾客：{{password}}\n顾客登录后将被要求设置新密码。此密码仅显示一次，请立即复制。",
      tempPasswordCopied: "已复制",
      totalCustomers: "顾客总数",
      enabledCount: "已启用",
      disabledCount: "已停用",
    },
    // Staff applications
    stallApplications: {
      title: "档口入驻申请",
      pageSubtitle: "审核档口入驻资料并管理批准或拒绝流程",
      statTotal: "申请总数",
      statPending: "待审核",
      statApproved: "已批准",
      statRejected: "已拒绝",
      statBadgeOverall: "汇总",
      statBadgePending: "待处理",
      statBadgeApproved: "通过",
      statBadgeRejected: "拒绝",
      colCreatedAt: "申请时间",
      colStallName: "档口名称",
      colCategory: "类别",
      colContact: "联系人",
      colStatus: "状态",
      colReviewer: "审核人",
      colActions: "操作",
      filterStatus: "筛选状态",
      viewDetail: "查看详情",
      detailTitle: "申请详情",
      labelDescription: "简介",
      labelContactPhone: "联系电话",
      labelContactEmail: "电子邮件",
      labelReviewNote: "审核备注",
      labelAppliedAt: "申请时间",
      sortOrderLabel: "档口排序（数值越小越靠前）",
      reviewNoteOptional: "审核备注（可选）",
      rejectionPlaceholder: "请填写拒绝原因…",
      reviewNotePlaceholder: "可填写备注（可选）",
      confirmApprove: "确认批准",
      confirmReject: "确认拒绝",
      approveModalTitle: "批准档口申请",
      rejectModalTitle: "拒绝档口申请",
      approveDescription: "批准后将自动在系统中创建档口「{{name}}」。",
      rejectDescription: "您将拒绝「{{name}}」的入驻申请。",
      status: {
        pending: "待审核",
        approved: "已批准",
        rejected: "已拒绝",
      },
      approve: "批准申请",
      reject: "拒绝申请",
      reviewNote: "审核备注",
      rejectionReason: "拒绝原因（至少5个字符）",
      approvedMsg: "申请已批准，档口已自动创建！",
      rejectedMsg: "申请已拒绝。",
      failedMsg: "操作失败，请重试。",
    },
    // Dashboard
    dashboard: {
      unitsSold: "已售 {{count}} 份",
      orderFlowTitle: "订单处理",
      orderFlowSubtitle: "备餐、取餐与配送概览",
      todayRevenue: "今日营收",
      todayOrders: "今日订单",
      pendingRefunds: "待处理退款",
      activeStaff: "在职员工",
      totalRevenue: "总营收",
      totalOrdersToday: "今日订单总数",
      pickupOrders: "自取订单",
      deliveryOrders: "外卖订单",
      newNow: "待接单",
      todayOrdersShort: "今日订单",
      preparingNow: "备餐中",
      readyForPickup: "待取餐",
      readyForDelivery: "待配送",
      channelDistribution: "渠道分布",
      revenueTrend: "营收趋势",
      revenueTrendSub: "全渠道日度表现",
      todayTab: "今日",
      weeklyTab: "本周",
      topSelling: "热销商品",
      noSalesToday: "今日暂无销售数据",
      recentActivity: "近期动态",
      viewAllHistory: "查看全部记录",
      colOrderId: "订单编号",
      colChannel: "渠道",
      colCustomer: "顾客",
      colAmount: "金额",
      colStatus: "状态",
      colTime: "时间",
      colAction: "操作",
      viewDetails: "查看详情",
      ordersUnit: "单",
      today: "今日",
      fromYesterday: "较昨日",
      current: "当前",
      todayLabel: "今日",
      pickup: "自取",
      delivery: "外卖",
      tooltipRevenue: "营收",
      topItemOrders: "{{count}} 单",
      topItemPeriodToday: "今日",
      topItemPeriodAll: "全部数据",
      donutPickupShare: "自取占比",
      avgOrderValue: "平均订单金额",
      pickupShare: "自取占比",
      deliveryShare: "外卖占比",
      revenueMovement: "营收变化",
      revenueUp: "上升",
      revenueDown: "下降",
    },
    // Menu
    menu: {
      title: "菜单管理",
      addItem: "添加菜品",
      editTitle: "编辑菜品",
      addTitle: "添加菜品",
      selectStallPrompt: "请选择档口以查看菜品",
      colImage: "图片",
      colName: "名称",
      colCategory: "分类",
      colPrice: "价格",
      colAvailable: "是否上架",
      colStock: "库存",
      formImage: "图片",
      formName: "名称",
      formDescription: "描述",
      formCategory: "分类",
      formPrice: "价格 (RM)",
      formDailyStock: "每日库存上限（留空 = 不限）",
      formDailyStockPlaceholder: "例如：50",
      formAvailableFrom: "供应开始时间 (HH:MM)",
      formAvailableTo: "供应结束时间 (HH:MM)",
      formTimeAvailableFromPh: "07:00",
      formTimeAvailableToPh: "22:00",
      formOfferPricePlaceholder: "例如：4.50",
      formTimeOfferFromPh: "10:00",
      formTimeOfferToPh: "14:00",
      formIsAvailable: "是否上架",
      formSortOrder: "排序权重",
      formOfferPrice: "优惠价 (RM)（留空 = 无优惠）",
      formOfferFrom: "优惠开始时间 (HH:MM)",
      formOfferTo: "优惠结束时间 (HH:MM)",
      createSuccess: "菜品已创建",
      updateSuccess: "菜品已更新",
      deleteConfirm: "确定删除此餐品？",
      deleteSuccess: "菜品已删除",
      saveFailed: "保存失败",
      deleteFailed: "删除失败",
      manageOptions: "选项组",
      optionsDrawerTitle: "选项组管理 — {{name}}",
      addGroup: "添加选项组",
      categoryOptionGroups: "默认选项组",
      categoryOptionGroupsTooltip: "新建此分类下的菜品时，会自动带上这些选项组（例如糖度、冰量、辣度等），可自行命名与增删。",
      categoryOptionGroupsEmpty: "暂无默认选项组",
      categoryOptionGroupNamePlaceholder: "选项组名称，如：辣度",
      categoryOptionChoicePlaceholder: "如：微辣",
      categoryAddOptionGroup: "添加选项组",
      editGroup: "编辑选项组",
      groupName: "选项组名称",
      groupType: "类型",
      groupTypeRequired: "必选",
      groupTypeOptional: "可选",
      groupMinSelect: "最少选择",
      groupMaxSelect: "最多选择",
      addChoice: "添加选项",
      editChoice: "编辑选项",
      choiceLabel: "选项名称",
      choiceExtraCharge: "额外收费 (RM)",
      groupSaved: "选项组已保存",
      groupDeleted: "选项组已删除",
      choiceSaved: "选项已保存",
      choiceDeleted: "选项已删除",
      confirmDeleteGroup: "确认删除此选项组？",
      confirmDeleteChoice: "确认删除此选项？",
      formGroupIcon: "图标",
      groupIconSugar: "糖度",
      groupIconIce: "冰量",
      groupIconSpecial: "特殊备注",
      choiceInputType: "类型",
      choiceTypeRadio: "单选",
      choiceTypeInputBox: "输入框",
      choiceTypeTextarea: "多行文本",
      choiceTypeQuantity: "数量加购",
      choiceTypeHelp: "类型说明：单选 = 点选（可设加价）；数量加购 = 收费加料，顾客用 − ＋ 选数量（如 火腿 RM1.50）；输入框 / 多行文字 = 只让顾客自己输入文字备注，不能选数量、不按份数收费。",
      choicePlaceholderLabel: "占位提示文字",
      choicePlaceholderExample: "例如：有什么特殊要求？",
      yourStalls: "我的档口",
      stallBadgeActive: "营业中",
      stallBadgePaused: "已暂停",
      selectStallFromLeft: "请选择一个档口以管理菜单。",
      managingSummary: "{{items}} · {{categories}}",
      itemCount_one: "{{count}} 个商品",
      itemCount_other: "{{count}} 个商品",
      categoryCount_one: "{{count}} 个分类",
      categoryCount_other: "{{count}} 个分类",
      colHeaderItemName: "商品名称",
      colHeaderCategory: "分类",
      sortTitle: "拖拽排序", listView: "列表", sortView: "拖拽排序", searchPlaceholder: "搜索商品名称", allCategories: "全部分类", uncategorized: "未分类", sortHint: "按住 ⠿ 拖动商品调整顺序，松手自动保存。顾客菜单按这个顺序显示（置顶商品始终在最前）。", sortFilteredHint: "当前只显示筛选后的商品，调整只影响它们之间的相对顺序。", sortSaved: "排序已保存", sortFailed: "排序保存失败", sortEmpty: "没有符合条件的商品", sortPinned: "置顶", sortUnavailable: "已下架", sortTop: "移到最前", sortUp: "上移", sortDown: "下移", noMatch: "没有符合条件的商品",
      colHeaderPriceRm: "价格 (RM)",
      colHeaderAvailability: "上架",
      colHeaderLastUpdated: "最近更新",
      stallPanelTitle: "档口详情",
      stallIdLabel: "档口编号：#{{id}}",
      stallStatusTitle: "档口状态",
      stallOnline: "在线",
      stallOffline: "离线",
      pauseOrdersHint: "暂停接单（临时）",
      prepTimeSection: "备餐时间",
      prepTimeMins: "分钟",
      autoAcceptTitle: "自动接单",
      autoAcceptHint: "高客流时建议开启",
      manageCategories: "分类管理",
      categoriesDrawerTitle: "分类管理 — {{stall}}",
      addCategory: "添加分类",
      editCategory: "编辑分类",
      categoriesEmptyTitle: "还没有分类",
      categoriesEmptyHint: "点击「添加分类」，为这个档口整理菜品分类。",
      categoryName: "分类名称",
      categorySortOrder: "排序",
      categoryCreateSuccess: "分类已创建",
      categoryUpdateSuccess: "分类已更新",
      categoryDeleteSuccess: "分类已删除",
      formCategoryId: "分类",
      formCategoryPlaceholder: "选择分类（可选）",
      formCategoryEmoji: "表情符号",
      formCategoryName: "分类名称",
      categoryEmoji: "表情",
      globalCategory: "全局",
      categoryEmojiHint: "粘贴单个表情（如 ☕）。若已上传图标，图标将优先显示",
      categoryIcon: "图标 / 图片",
      categoryIconHint: "上传自定义图标或图片（优先于表情显示）",
      formCategoryEmojiPlaceholder: "例如：☕",
      categoryStallOptional: "可选 — 留空表示全局分类",
      categorySugarChoices: "糖度选项",
      categorySugarChoicesTooltip:
        "若设置，该分类下商品将使用这些糖度选项；留空则使用应用默认。",
      categorySugarChoicesEmpty: "使用应用默认",
      categorySugarChoicesPlaceholder: "如：少糖 25%",
      categoryIceChoices: "冰量选项",
      categoryIceChoicesTooltip:
        "若设置，该分类下商品将使用这些冰量选项；留空则使用应用默认。",
      categoryIceChoicesEmpty: "使用应用默认",
      categoryIceChoicesPlaceholder: "如：少冰",
    },
    // Transactions
    transactions: {
      title: "交易记录",
      searchPlaceholder: "搜索参考号",
      filterStatus: "状态",
      statusSuccess: "成功",
      statusPending: "待处理",
      statusRefunded: "已退款",
      statusFailed: "失败",
      refundBtn: "退款",
      refundModalTitle: "退款",
      refundOriginal: "原始金额：",
      refundPaidVia: "支付方式：",
      refundType: "退款类型",
      refundTypeFull: "全额退款",
      refundTypePartial: "部分退款",
      refundAmount: "退款金额 (RM)",
      refundMethod: "退款方式",
      refundReason: "退款原因",
      refundReasonPlaceholder: "请填写退款原因…",
      submitRefund: "提交退款",
      refundInitiated: "退款已提交，待审核",
      refundFailed: "提交退款失败",
      pageTitle: "交易记录",
      statTotalTxns: "总交易笔数",
      statTotalRevenue: "实收金额 (RM)",
      statTotalRevenueHint: "成功交易的实收金额；与「报表」页的订单总额口径不同（订单总额含未付款订单、不含已取消订单）",
      statTotalRefunded: "已退款 (RM)",
      statNetRevenue: "净营收 (RM)",
      searchPlaceholderWide: "按交易编号、顾客或订单号搜索…",
      datePreset7d: "近 7 天",
      datePreset30d: "近 30 天",
      datePreset90d: "近 90 天",
      datePresetAll: "全部",
      filterAllPaymentMethods: "全部支付方式",
      filterAllStatus: "全部状态",
      filterAllOrderTypes: "全部订单类型",
      filterAllSources: "全部来源",
      sourceWalkin: "堂食（POS）",
      sourceCustomerApp: "客户端",
      statusPartialRefund: "部分退款",
      colTxnId: "交易编号",
      colCustomerOrder: "顾客 / 订单",
      customerLabel: "顾客",
      colOrderType: "订单类型",
      colAmount: "金额",
      colPayment: "支付",
      colStatus: "状态",
      colDateTime: "日期与时间",
      actionViewDetails: "查看详情",
      actionRefunds: "退款",
      actionReceipt: "小票",
      partialRefNote: "部分退",
      testFailedGeneric: "测试失败",
    },
    // Refunds
    refunds: {
      title: "退款管理",
      pageHeading: "退款",
      colId: "编号",
      colAmount: "金额",
      colReason: "原因",
      colPaymentRef: "支付参考号",
      colStatus: "状态",
      colRequested: "申请时间",
      colActions: "操作",
      colRefundId: "退款编号",
      colTxnId: "交易编号",
      colCustomerOrder: "顾客 / 订单",
      colType: "类型",
      colAction: "操作",
      filterStatus: "筛选状态",
      statusPendingReview: "待审核",
      statusApproved: "已批准",
      statusRejected: "已拒绝",
      approve: "批准",
      reject: "拒绝",
      approveTitle: "批准退款",
      rejectTitle: "拒绝退款",
      noteLabel: "内部备注（选填）",
      notePlaceholder: "添加备注以便审计…",
      approvedMsg: "退款已批准",
      rejectedMsg: "退款已拒绝",
      reviewFailed: "审核处理失败",
      statTotalAmount: "已退款总额（仅成功）",
      statTotalCount: "已退款笔数（仅成功）",
      statPartialCount: "部分退款笔数（仅成功）",
      statTodayAmount: "今日已退款金额（仅成功）",
      statSubVsLastMonth: "较上月 {{pct}}",
      statSubNoLastMonth: "上月无退款",
      statAccumulatedMonth: "本月累计 · 待处理的不计入",
      statPartialPct: "占总笔数 {{pct}}%",
      statUpdatedNow: "刚刚更新",
      dateRange: "日期范围",
      refundType: "退款类型",
      paymentMethod: "支付方式",
      status: "状态",
      quickSearch: "快速搜索",
      placeholderAllTypes: "全部类型",
      placeholderAllMethods: "全部方式",
      placeholderAllStatus: "全部状态",
      placeholderSearch: "交易编号 / 姓名",
      typeFull: "全额退款",
      typePartial: "部分退款",
      statusPending: "待处理",
      statusSuccess: "成功",
      statusRejectedPill: "已拒绝",
      statusFailed: "失败",
      typeFullRef: "全额",
      typePartialRef: "部分",
      pillSuccess: "成功",
      pillPending: "待处理",
      pillRejected: "已拒绝",
      pillFailed: "失败",
      recentRecords: "最近退款记录",
      exportCsv: "导出 CSV",
      exportPdf: "导出 PDF",
      menuUpdateStatus: "更新状态",
      menuViewDetails: "查看详情",
      menuViewOrders: "查看订单",
      statusUpdated: "退款状态已更新",
      statusUpdateFailed: "更新状态失败",
      modalTitle: "更新退款状态",
      modalRefundId: "退款编号：",
      summaryTitle: "退款摘要",
      customer: "顾客",
      orderId: "订单号",
      transactionId: "交易编号",
      refundAmount: "退款金额",
      currentStatus: "当前状态：",
      updateStatus: "更新状态",
      optCompleted: "已完成",
      optRejected: "已拒绝",
      transferDetails: "转账信息",
      transferMethod: "退款方式",
      transferMethodRequired: "请选择退款方式",
      transferTime: "转账时间",
      referenceNote: "参考备注",
      rejectionReason: "拒绝原因",
      placeholderTransferMethod: "选择方式",
      placeholderTransferTime: "MM/DD/YYYY, HH:MM",
      placeholderReference: "如：Maybank 凭证 #8812",
      placeholderRejection: "填写拒绝原因…",
      transferEwallet: "电子钱包",
      transferBank: "银行转账",
      transferCash: "现金",
      transferFpx: "FPX",
      transferCard: "Visa/卡",
      warnConfirmTransfer: "请确认退款已成功转出，此操作不可撤销。",
      cancel: "取消",
      confirmUpdate: "确认更新",
      payVisa: "Visa / 卡",
      payFpx: "FPX",
      payGrab: "GrabPay",
      payCash: "现金",
      payEwallet: "电子钱包",
      payTng: "Touch 'n Go",
      payBoost: "Boost",
      autoRefundTitle: "通过 Fiuu 自动退款",
      autoRefundDesc: "此退款将通过 Fiuu 自动处理，原路退回顾客的付款方式，无需填写手动转账信息。",
      warnConfirmAutoRefund: "此操作将向 Fiuu 发起真实的退款请求，且不可撤销。",
      autoRefundSuccessToast: "退款已自动处理 —— 款项已通过 Fiuu 退回",
      autoRefundPendingToast: "退款已提交至 Fiuu —— 仍在处理中，请稍后查看",
      autoRefundFailedToast: "Fiuu 拒绝了此次退款{{reason}}",
    },
    // Vouchers
    vouchers: {
      sectionDistribution: "发放与叠加",
      lblScope: "优惠券范围",
      scopePlatform: "平台券（任意档口）",
      scopeMerchant: "商家券（仅单个档口）",
      lblDiscountTarget: "优惠项目",
      targetSubtotal: "商品小计",
      targetDeliveryFee: "配送费",
      lblMerchantStall: "所属档口",
      merchantStallRequired: "请选择该商家券所属的档口",
      phMerchantStall: "选择档口",
      lblNoMinimum: "无门槛（红包）",
      lblDailyUseCap: "每日使用上限",
      phUnlimited: "不限",
      stackingHint: "每笔订单最多可叠加 3 张券：商家券、平台券和配送费券各一张，按此顺序在计算 SST 前抵扣。",
      title: "优惠券",
      pageSubtitle: "创建、追踪和管理顾客促销活动",
      newVoucher: "新建优惠券",
      editTitle: "编辑优惠券",
      newTitle: "新建优惠券",
      colMinSpend: "最低消费",
      colUses: "使用次数",
      colStatus: "状态",
      colValidUntil: "有效期至",
      formCode: "券码",
      formDiscountType: "折扣类型",
      formDiscountTypePercentage: "百分比折扣 %",
      formDiscountTypeFixed: "固定金额 (RM)",
      formDiscountTypeFreeItem: "免费商品",
      formDiscountValue: "折扣值",
      formMinSpend: "最低消费 (RM)",
      formUsageLimit: "使用上限（留空 = 不限）",
      formValidFrom: "有效期开始",
      formValidUntil: "有效期结束",
      formStatus: "状态",
      formStatusActive: "有效",
      formStatusScheduled: "已排期",
      formStatusExpired: "已过期",
      formStatusDisabled: "已停用",
      formStatusInactive: "无效",
      formSingleUse: "每客户单次使用",
      createSuccess: "优惠券已创建",
      updateSuccess: "优惠券已更新",
      saveFailed: "保存失败",
      deleteConfirm: "确认停用此优惠券？",
      deleteConfirmDesc: "停用后将不可再使用。",
      deleteSuccess: "优惠券已停用",
      deleteFailed: "停用优惠券失败",
      pageCreateBtn: "创建优惠券",
      statBadgeOverall: "汇总",
      statBadgeActive: "有效",
      statBadgeInactive: "无效",
      statBadgeGrowth: "累计",
      statTotalVouchers: "优惠券总数",
      statActive: "有效",
      statExpired: "已过期",
      statTotalRedeemed: "总核销次数",
      searchPlaceholder: "按券码或名称搜索…",
      filterAllStatus: "全部状态",
      filterAllTypes: "全部类型",
      colCode: "券码",
      colVoucherName: "名称",
      colType: "类型",
      colValue: "面值",
      colMinOrder: "最低订单",
      colUsage: "用量",
      colValidPeriod: "有效期",
      colStatusHeader: "状态",
      colActions: "操作",
      ongoing: "长期有效",
      menuEdit: "编辑",
      menuUsage: "查看用量",
      menuDistribute: "发放给顾客",
      menuDelete: "删除",
      distributeTitle: "发放「{{code}}」给顾客",
      sendToWallet: "发送到钱包",
      distributeHint: "按电话号码或姓名搜索，然后选择顾客，将此优惠券直接放入他们的钱包。",
      distributeSearch: "搜索电话号码或姓名…",
      distributeSelect: "选择顾客",
      distributionSuccess: "已将优惠券发放给 {{count}} 位顾客",
      usageTitle: "使用记录 —「{{code}}」",
      usageEmpty: "此优惠券尚未在任何订单中核销。",
      usageSlot: "优惠来源",
      usageDiscount: "优惠金额",
      slotMerchantPlatform: "商家／平台",
      slotPlatform: "平台",
      slotDeliveryFee: "配送费",
      typeTagPercentage: "百分比",
      typeTagFixed: "固定金额",
      typeTagFreeItem: "免运费",
      drawerSubtitleNew: "请在下方配置促销详情",
      btnCancel: "取消",
      btnSaveChanges: "保存更改",
      btnSaveVoucher: "保存优惠券",
      sectionBasic: "基本信息",
      sectionDiscount: "折扣设置",
      sectionUsage: "使用限制",
        sectionAutoGrant: "自动发放",
        lblAutoGrantTrigger: "自动发放触发条件",
        autoGrantNone: "不自动发放（仅手动/广播领取）",
        autoGrantFirstOrder: "客户完成首笔订单时",
        autoGrantHint: "设置后，客户满足触发条件时会自动获得这张券，无需自己领取。",
      sectionValidity: "有效期",
      sectionApplicable: "适用范围",
      lblVoucherName: "优惠券名称",
      phVoucherName: "例如：周末咖啡特惠",
      lblVoucherCode: "券码",
      codeRequired: "请填写券码",
      btnAutoGenerate: "自动生成",
      lblDescription: "描述",
      lblVoucherImage: "优惠券图片（缩略图）",
      tabPercentage: "百分比",
      tabFixedRm: "固定金额",
      tabFreeDelivery: "免运费",
      tabApplicableAll: "全部",
      tabApplicablePickup: "自取",
      tabApplicableDelivery: "外卖",
      lblValuePct: "折扣值 (%)",
      lblMaxCapRm: "封顶 (RM)",
      lblDiscountAmountRm: "折扣金额 (RM)",
      freeDeliveryHint: "将全额免除配送费",
      lblMinOrderRm: "最低订单金额 (RM)",
      lblTotalUsageLimit: "总使用次数上限",
      lblPerCustomer: "每客户限用",
      lblStartDate: "开始日期",
      lblEndDate: "结束日期",
      enableImmediatelyTitle: "保存后立即启用",
      enableImmediatelyHint: "保存后状态将为「有效」",
      filterStatusActive: "有效",
      filterStatusScheduled: "已排期",
      filterStatusExpired: "已过期",
      filterStatusDisabled: "已停用",
      filterTypePercentage: "百分比",
      filterTypeFixed: "固定金额",
      filterTypeFreeItem: "免运费/赠品",
    },
    // Bundles
    bundles: {
      title: "套餐管理",
      pageTitle: "促销活动",
      pageSubtitle: "创建、定价和管理套餐促销活动",
      newBundle: "新建套餐",
      createBundle: "创建套餐",
      editTitle: "编辑套餐",
      newTitle: "新建套餐",
      colName: "名称",
      colBundlePrice: "套餐价格",
      colOriginalPrice: "原价",
      colFor: "适用于",
      colValid: "有效期",
      colActive: "是否启用",
      formName: "名称",
      formDescription: "描述",
      formItemsLabel: "商品（先选档口）",
      formStall: "档口",
      formItemsJson: "套餐商品 (JSON)",
      formOriginalPrice: "原价 (RM)",
      formBundlePrice: "套餐价格 (RM)",
      formApplicableFor: "适用于",
      formApplicableBoth: "两者",
      formApplicablePickup: "自取",
      formApplicableDelivery: "外卖",
      formValidityPeriod: "有效期",
      formIsActive: "是否启用",
      confirmDelete: "确认删除此套餐？",
      deleteTitle: "删除此套餐？",
      deleteContent: "此操作不可恢复。",
      deleteBtn: "删除",
      createSuccess: "套餐已创建",
      updateSuccess: "套餐已更新",
      deleteSuccess: "套餐已删除",
      saveFailed: "保存套餐失败",
      deleteFailed: "删除套餐失败",
      statTotal: "套餐总数",
      statActive: "启用",
      statDisabled: "停用",
      statBadgeOverall: "汇总",
      statBadgeActive: "启用",
      statBadgeDisabled: "未启用",
      searchPlaceholder: "搜索套餐名称…",
      statusAll: "状态：全部",
      statusActiveOnly: "启用",
      statusDisabledOnly: "停用",
      applicableAll: "适用：全部",
      applicableBoth: "自取与外卖",
      applicablePickup: "仅自取",
      applicableDelivery: "仅外卖",
      tabAll: "全部",
      tabPickup: "自取",
      tabDelivery: "外卖",
      loading: "加载中…",
      empty: "暂无套餐。",
      drawerSubtitleCreate: "在下方配置套餐详情",
      cancel: "取消",
      saveChanges: "保存更改",
      saveBundle: "保存套餐",
      sectionBasic: "基本信息",
      bundleName: "套餐名称",
      nameRequired: "请填写套餐名称",
      namePlaceholder: "如：早餐套餐",
      description: "描述",
      sectionItems: "套餐内商品",
      addItem: "添加商品",
      searchItemPlaceholder: "按名称或档口搜索…",
      noItemsFound: "未找到商品",
      noItemsYet: "尚未添加商品",
      originalTotal: "原价合计：",
      sectionBundlePrice: "套餐价",
      splitCost: "分账成本（每件）",
      splitTotal: "分账成本合计",
      platformKeeps: "平台留存 RM {{amount}}",
      splitOverWarning: "分账成本合计超出套餐价 RM {{amount}}，每份套餐平台都会亏损。",
      bundlePriceRm: "套餐价 (RM)",
      originalPrice: "原价",
      bundlePriceRow: "套餐价",
      customerSaves: "顾客节省",
      sectionApplicable: "适用方式",
      setExpiry: "设置有效期",
      noExpiryHint: "此套餐不设过期。",
      startDate: "开始日期",
      endDate: "结束日期",
      activeStatus: "启用状态",
      activeStatusHint: "停用后顾客端不显示，但不会删除。",
      pillActive: "启用",
      pillDisabled: "停用",
      previewAction: "预览",
      unknownStall: "未知档口",
    },
    // Reports
    settlement: {
      gross: "总营收（标价口径）",
      stallFee: "商品扣除（按档口菜单价）",
      addonFee: "加料扣除（按加料原价）",
      bundleFee: "套餐扣除（按套餐价）",
      bundleShare: "套餐折扣分摊",
      cutlery: "其中餐具费",
      net: "净营收（应付）",
      deductions: "扣除合计",
      orders: "订单数",
      stall: "档口",
      allStalls: "全部档口",
      from: "开始日期",
      to: "结束日期",
      byStall: "按档口汇总",
      byOrder: "按订单（应付给每个档口的金额）",
      orderCode: "订单",
      orderTime: "下单时间",
      exportSettlement: "导出结算 CSV",
      exportLines: "导出订单明细 CSV",
      exportBundles: "导出套餐 CSV",
      invalidRange: "开始日期不能晚于结束日期。",
      formulaHint: "这是档口视角的结算：总营收 = 档口菜单价 + 加料原价；商品扣除 = 菜单价 ≤ 阈值的固定金额，高于阈值的按百分比；加料扣除按加料原价的百分比；套餐扣除按套餐价按同一规则；净营收（应付）= 总营收 − 商品扣除 − 加料扣除 − 套餐扣除 − 套餐折扣分摊。不含顾客侧的加价。所有数字取自订单下单当时记录的金额，已取消订单和被拒绝的商品不计入。",
    },
    reports: {
      title: "报表分析",
      granularityHourly: "按小时",
      granularityDaily: "按天",
      granularityWeekly: "按周",
      granularityMonthly: "按月",
      presetToday: "今天",
      presetLast7: "近7天",
      presetLast30: "近30天",
      presetThisMonth: "本月",
      chartRevenueOrders: "营收与订单趋势",
      chartNoData: "所选时段暂无数据",
      chartRevenueByStall: "各档口营收",
      chartNoDataShort: "暂无数据",
      tableStallBreakdown: "档口明细",
      colStall: "档口",
      colRevenue: "营收",
      colOrders: "订单数",
      colAvgOrder: "平均订单",
      tableTotal: "合计",
      dataRange: "数据范围：{{from}} 至 {{to}}",
      tabFinancial: "财务",
      tabRisk: "风险",
      tabStalls: "档口销售",
      tabStaff: "员工动态",
      tabPricing: "定价明细",
      tabSettlement: "档口结算",
      colQty: "数量",
      colBasePriceTotal: "原价总额",
      colMarkupTotal: "顾客加价（平台向顾客收取）",
      colBundleDiscount: "套餐优惠",
      colStallDeduction: "档口扣除（平台向档口收取）",
      colPlatformIncome: "平台合计收入（顾客加价 + 档口扣除）",
      colSstIncluded: "价格内含 SST（不计入营收/平台收入）",
      colOptionsTotal: "加料总额",
      colOptionsMarkupTotal: "加料顾客加价",
      pricingBreakdownTitle: "原价与加价明细（按月）",
      pricingBreakdownSub: "按档口统计的原价与加价总额，可按档口和订单类别（堂食 vs 客户端）筛选。堂食订单的加价始终为 RM0.00。",
      filterMonth: "月份",
      filterStall: "档口",
      filterAllStalls: "全部档口",
      filterCategory: "订单类别",
      categoryAll: "全部订单",
      categoryWalkin: "堂食（POS）",
      categoryCustomerApp: "客户端",
      rowGrandTotal: "总计",
      periodToday: "今日",
      periodWeek: "本周",
      periodMonth: "本月",
      cardTotalRevenue: "订单总额（不含已取消）",
      cardTotalRefunds: "总退款",
      refundTxCount: "{{count}} 笔已完成的退款（待处理的不计入）",
      cardNetRevenue: "净营收",
      afterRefunds: "= 订单总额 − 已计入订单的退款",
      cardTotalRevenueHint: "订单总额 = 本期所有未取消订单的金额合计（含未付款订单）。「交易记录」页的实收金额只统计已成功的付款，口径不同。",
      refundsOnCancelled: "另有 {{count}} 笔退款（RM {{amount}}）属于已取消订单，未计入营收",
      colCancelledRefunds: "已取消订单退款",
      cardTotalOrders: "总订单",
      pickupDelivery: "外送与自取",
      revVsLastPeriod: "较上期 {{pct}}%",
      legendRevenue: "营收",
      legendOrders: "订单",
      salesTrend: "销售趋势",
      paymentMethods: "支付方式",
      payMixEwallet: "电子钱包 (TNG / GoPay)",
      payMixCard: "信用卡 / 借记卡",
      payMixCash: "现金",
      topPerformer: "最佳渠道",
      topPerformerSub: "椰浆饭电子钱包用户",
      revenueTrend: "营收走势",
      revenueTrendSub: "每日财务表现概览",
      legendRefunds: "退款",
      dailyBreakdown: "每日明细",
      colDate: "日期",
      colRefunds: "退款",
      colNetRevenue: "净营收",
      recentFinancialTx: "近期财务流水",
      viewAll: "查看全部",
      colTxnId: "交易编号",
      colStatus: "状态",
      colMethod: "方式",
      colAmount: "金额",
      riskCancelRate: "取消率",
      riskRefundRate: "退款率",
      cancelledOrdersCount: "{{count}} 单已取消",
      refundedOrdersCount: "{{count}} 单已退款",
      riskCancelledOrders: "取消订单数",
      thisPeriod: "本周期",
      riskRefundedAmt: "已退金额",
      totalRefundedHint: "累计退款",
      highRiskOrders: "高风险订单",
      colOrderId: "订单号",
      colCustomerName: "顾客",
      colOrderType: "类型",
      colReason: "原因",
      colActions: "操作",
      paginationShowing: "显示第 {{start}}–{{end}} 条，共 {{total}} 条",
      salesByStallTitle: "各档口销售额 (RM)",
      salesByStallSub: "按摊主拆分的营收",
      revenueShare: "营收占比",
      donutTotal: "合计",
      topItemsTitle: "档口热销品",
      topItemsSub: "餐品表现排名",
      colRank: "排名",
      colItemName: "品项",
      colUnitsSold: "销量",
      colRevenueRm: "营收 (RM)",
      colPerformance: "表现",
      colCommission: "佣金",
      commissionThreshold: "阈值（≤）",
      commissionFlatFee: "固定费用",
      commissionPercent: "百分比（>阈值）",
      commissionSave: "保存佣金规则",
      addonCommissionPercent: "加料扣除率（%）",
      commissionReportOnlyHint: "以上比率仅用于本报表自身的成本扣除/对账计算，与「定价规则」完全独立，不会影响顾客结账时实际支付的金额。",
      staffBadgeVsLw: "较上周 +12%",
      staffActiveToday: "今日在岗",
      staffRegisteredOf: "/ 注册 {{count}} 人",
      avgSessionDuration: "平均在线时长",
      perStaffToday: "今日人均",
      totalLoginSessions: "登录次数",
      includingRelogins: "含重复登录",
      staffLoginLogTitle: "员工登入 / 登出记录",
      staffLoginLogSub: "平板设备会话监控",
      searchStaffPh: "搜索员工姓名…",
      colStaffName: "员工",
      colDevice: "设备",
      colLoginTime: "登录",
      colLogoutTime: "登出",
      colDuration: "时长",
      ongoing: "（进行中）",
      sessionFootnote: "* 记录员工在平板 POS 的登入与登出，时长实时更新。",
      statusCancelled: "已取消",
      statusRefunded: "已退款",
      staffOnline: "● 在线",
      staffOnlineRelogin: "● 在线（重登）",
      staffLoggedOut: "已登出",
      demo: {
        dash: "—",
        avgSessionSample: "5小时22分",
        riskStatCancelRate: "4.2%",
        riskStatRefundRate: "1.0%",
        riskRefundedAmount: "RM 185.00",
        risk: {
          trm1042: { customer: "Ahmad Fadzil", reason: "无可用骑手" },
          trm1038: { customer: "Sarah Lim", reason: "送错餐品" },
          trm1035: { customer: "John Tan", reason: "配送延误（超过45分钟）" },
          trm1031: { customer: "Mei Ling", reason: "顾客未到场" },
        },
        staff: {
          s0: {
            name: "Ahmad Bakar",
            device: "平板 1",
            login: "上午7:02",
            logout: "—",
            duration: "7小时13分",
          },
          s1: {
            name: "Siti Aminah",
            device: "平板 2",
            login: "上午8:15",
            logout: "下午2:15",
            duration: "6小时00分",
          },
          s2: {
            name: "Jason Tan",
            device: "平板 1",
            login: "上午9:00",
            logout: "—",
            duration: "5小时15分",
          },
          s3: {
            name: "Mary Jane",
            device: "平板 2",
            login: "上午7:30",
            logout: "中午12:00",
            duration: "4小时30分",
          },
          s4: {
            name: "Mary Jane",
            device: "平板 2",
            login: "下午1:00",
            logout: "—",
            duration: "3小时15分",
          },
          s5: {
            name: "Lee Chong Wei",
            device: "平板 1",
            login: "上午6:45",
            logout: "下午3:30",
            duration: "8小时45分",
          },
        },
        top: {
          nasi: [
            "椰浆饭香料鸡",
            "椰浆饭（普通）",
            "椰浆饭鱿鱼参巴",
            "加参巴（附加）",
          ],
          drinks: ["拉茶", "冰美禄", "冰柠檬茶 O", "咖啡 O"],
          wok: ["炒饭", "炒粿条", "嘛嘛炒面"],
          mamak: ["印度煎饼", "炒快熟面", "馕饼配咖喱"],
        },
      },
    },
    // Activity Log
    activity: {
      title: "操作日志",
      colStaff: "员工",
      colAction: "操作",
      colEntity: "对象",
      colDetails: "详情",
      colIp: "IP 地址",
      colTime: "时间",
      searchPlaceholder: "搜索员工、订单号（如 5906）或详情…",
      filterAction: "筛选操作",
      exportCsv: "导出 CSV",
      clearFilters: "清除筛选",
      allActions: "全部操作",
      eventsRecorded: "共 {{count}} 条记录",
      footerShowing: "第 {{page}} 页 · 共 {{total}} 条",
    },
    notifications: {
      deliveryFailedTitle: "配送失败 — 订单 {{code}}",
      title: "通知",
      markAllRead: "全部标记为已读",
      empty: "暂无通知。",
      resolved: "已处理",
      unresolved: "未处理",
    },
    imageUpload: {
      imagesOnly: "仅支持图片文件",
      maxSize: "图片须小于 5 MB",
      uploadFailed: "上传失败",
      upload: "上传",
      previewAlt: "已上传图片预览",
      clickOrDrag: "点击上传或拖拽文件到此处",
      hintFormats: "SVG、PNG、JPG（最大 5 MB），建议 1:1 高清图。",
      menuItemHint: "建议：1200×1200px，JPG 格式，1MB 以内。正方形构图，菜品居中——用于菜单列表和首页的缩略图。",
      stallHint: "支持 PNG、JPG 或 WebP，最大 5 MB。建议使用清晰的横版档口图片。",
      squareLabel: "方形图片（缩略图）",
      wideLabel: "横版图片（banner）",
      wideHint: "建议：1200×900px，JPG 格式，1MB 以内。横版构图，菜品居中——用于商品详情页的大图 banner。可不填，未设置时将使用方形图片。",
    },
    statusTag: {
      new: "新订单",
      pending: "待处理",
      confirmed: "已确认",
      preparing: "制作中",
      ready: "已备好",
      out_for_delivery: "外送中",
      in_transit: "运输中",
      delivered: "已送达",
      completed: "已完成",
      cancelled: "已取消",
      paid: "已付款",
      unpaid: "未付款",
      refunded: "已退款",
      partially_refunded: "部分退款",
      approved: "已通过",
      rejected: "已拒绝",
      pending_review: "待审核",
      active: "启用",
      inactive: "停用",
      open: "营业中",
      closed: "已打烊",
    },
    issueRefund: {
      title: "处理退款",
      notFound: "未找到交易。",
      txnId: "交易编号：",
      orderId: "订单号：",
      datePaid: "支付时间",
      back: "返回",
      sectionRefundType: "退款类型",
      fullRefund: "全额退款",
      fullRefundDesc: "将全额 RM {{amount}} 退回原支付渠道。",
      partialRefund: "部分退款",
      partialDesc: "指定退还给顾客的金额。",
      maxRefundable: "最多可退：RM {{amount}}",
      overLimit: "退款金额超过了可退上限 RM {{amount}}，请改小",
      sectionBreakdown: "金额明细",
      foodBev: "餐饮小计",
      deliveryFee: "送餐费",
      sst: "消费税 ({{rate}}%)",
      appliedDiscount: "已用优惠",
      refundAmountRow: "退款金额",
      totalRefundAmount: "退款合计",
      sectionReason: "原因与说明",
      refundReasonLabel: "退款原因",
      reasonPlaceholder: "请选择原因…",
      internalNote: "内部备注",
      internalOptional: "（选填）",
      internalPlaceholder: "供商户审计的补充说明…",
      sectionMethod: "退款方式",
      methodDescFallback: "将退回原支付渠道。",
      originalPaid: "原支付金额",
      settlementSummary: "结算摘要",
      warningIrreversible: "此操作不可撤销，退款将立即提交至支付网关。",
      confirmCheckbox: "本人已核对订单信息并授权本次退款。",
      confirmRefund: "确认退款",
      cancelReturn: "取消并返回",
      merchantId: "商户 ID：",
      authorizedBy: "操作人：",
      roleAdmin: "管理员",
      partialTipTitle: "部分退款提示",
      partialTipBody: "漏餐等情况请按税前单价计算，确保退款准确。",
      success: "退款已发起",
      failed: "发起退款失败，请重试。",
      payVisa: "Visa/卡 — 已验证",
      payFpx: "FPX — 已验证",
      payGrab: "GrabPay — 已验证",
      payCash: "现金",
      payEwallet: "电子钱包 — 已验证",
      payTng: "Touch 'n Go — 已验证",
      payBoost: "Boost — 已验证",
      descVisa: "退回原卡，约 5–7 个工作日。",
      descFpx: "退回原支付渠道，约 3–5 个工作日。",
      descGrab: "退回 GrabPay 钱包，约 1–3 个工作日。",
      descCash: "现场退还现金给顾客。",
      descEwallet: "退回原电子钱包，约 1–3 个工作日。",
      descTng: "退回 TNG 钱包，约 1–3 个工作日。",
      descBoost: "退回 Boost 钱包，约 1–3 个工作日。",
      reasonCustomerCancelled: "顾客取消",
      reasonOutOfStock: "缺货",
      reasonWrongItem: "错餐",
      reasonDuplicate: "重复支付",
      reasonNotDelivered: "未送达",
      reasonQuality: "质量问题",
      reasonOther: "其他",
    },
    receipt: {
      metaReceiptNo: "收据编号",
      metaOrderId: "订单号",
      metaDateTime: "日期时间",
      metaPaymentMethod: "支付方式",
      metaCustomerName: "顾客姓名",
      metaCustomerPhone: "顾客电话",
      metaOrderChannel: "下单渠道",
      tel: "电话",
      colItemName: "品项",
      colQty: "数量",
      colPriceRm: "单价 (RM)",
      colSubtotalRm: "小计 (RM)",
      subtotal: "小计",
      deliveryFee: "送餐费",
      discount: "优惠",
      totalPaid: "实付合计",
      sstPct: "SST ({{pct}}%)",
      refundedAmount: "已退金额",
      refundDate: "退款日期",
      thankYou: "感谢您的惠顾",
      systemGenerated: "本收据由系统自动生成",
      downloadPdf: "下载 PDF",
      printReceipt: "打印收据",
      close: "关闭",
      printTitle: "收据",
      optionsPlus: "+",
      payVisa: "Visa / 卡",
      payFpx: "FPX",
      payGrab: "GrabPay",
      payCash: "现金",
      payEwallet: "电子钱包",
      payTng: "Touch 'n Go",
      payBoost: "Boost",
      channelDelivery: "外送",
      channelPickup: "自取",
      channelOther: "订单",
    },
    addMenuItem: {
      titlePage: "新增餐品",
      titlePageEdit: "编辑餐品",
      successCreate: "餐品已创建",
      successUpdate: "餐品已更新",
      failedCreate: "创建餐品失败",
      failedUpdate: "更新餐品失败",
      successAnother: "已保存！请继续添加下一项。",
      sectionBasic: "基本信息",
      itemName: "餐品名称",
      itemNameRequired: "请填写餐品名称",
      namePlaceholder: "例如：椰浆饭炸鸡",
      stall: "摊位",
      tagRequired: "必填",
      selectStallPh: "选择摊位",
      category: "分类",
      selectCategoryPh: "选择分类",
      stallPaused: "{{name}} 当前已暂停营业，恢复营业前顾客无法点选此餐品。",
      description: "描述",
      descPlaceholder: "简短介绍此餐品",
      sectionPricing: "定价与上架",
      basePrice: "基础售价",
      priceRequired: "请填写价格",
      availableForOrder: "可点单",
      availableHint: "关闭后顾客菜单中隐藏",
      pinToTop: "置顶推荐",
      pinToTopHint: "在顾客菜单中优先显示此商品",
      advancedOptions: "高级选项",
      offerPrice: "优惠价 (RM)",
      dailyStock: "每日库存",
      dailyStockPh: "例如 50",
      takeawayCutlery: "外带餐具费",
      takeawayCutleryHint: "按每件收取，适用于顾客端自取和外送订单；顾客不能选择不要。",
      takeawayCutleryFee: "每件金额",
      takeawayCutleryFeeRequired: "请填写餐具费金额",
      sortOrder: "排序",
      availableFrom: "开售时间",
      availableUntil: "停售时间",
      offerFrom: "优惠开始",
      timePh: "07:00",
      timePhEnd: "22:00",
      timePhOffer: "10:00",
      sectionImage: "餐品图片",
      sectionCustomization: "定制选项",
      enableCustomization: "启用定制",
      custPromptTitle: "开启后可添加定制项",
      custPromptBody: "在上方打开「启用定制」，即可添加规格、加料、甜度等选项组。",
      noGroupsYet: "尚无选项组，点击「添加选项组」开始。",
      addOptionGroup: "添加选项组",
      copyExistingGroup: "从本档口已有菜品复制选项组…",
      icon: "图标",
      groupName: "组名称",
      groupNamePh: "组名（如：糖度、加料）",
      fieldRequired: "必选",
      selection: "选择方式",
      selectionSingle: "单选",
      selectionMultiple: "多选",
      min: "最少",
      max: "最多",
      removeGroup: "删除组",
      colOptionName: "选项名称",
      colPriceAdj: "加价 (RM)",
      colType: "类型",
      colDefault: "默认",
      optionNamePh: "选项名称",
      typeRadio: "单选",
      typeInput: "输入",
      typeTextarea: "多行",
      typeQuantity: "数量加购",
      addOption: "添加选项",
      customerPreview: "顾客端预览",
      selectStallPreview: "请先选择摊位",
      previewNameFallback: "餐品名称预览",
      previewDescHint: "在左侧填写描述后，将显示在这里。",
      badgeAvailable: "在售",
      badgeUnavailable: "下架",
      customizeYourOrder: "定制您的订单",
      mandatoryComplete: "必填项已填写完整",
      mandatoryIncomplete: "请完成必填项后继续",
      saveAddAnother: "保存并继续添加",
      saveItem: "保存餐品",
      groupIconSugar: "糖度",
      groupIconIce: "冰量",
      groupIconSpecial: "备注/特殊要求",
    },
    // Feature Flags
    featureFlags: {
      title: "功能开关",
      pageSubtitle: "集中管理平台功能、开放状态与上线范围。",
      statTotal: "功能总数",
      statEnabled: "已启用",
      statDisabled: "已停用",
      statBadgeTotal: "全部功能",
      statBadgeEnabled: "当前可用",
      statBadgeDisabled: "暂未开放",
      toggleLabel: "切换 {{key}}",
      colFlagKey: "功能键",
      colDescription: "描述",
      colEnabled: "是否启用",
      noDescription: "暂无描述",
      flagEnabled: "功能 \"{{key}}\" 已启用",
      flagDisabled: "功能 \"{{key}}\" 已禁用",
      updateFailed: "更新功能开关失败",
      desc_lalamove_enabled: "为外卖订单启用 Lalamove 骑手派送",
      desc_email_otp_enabled: "短信验证码发送失败时改用邮箱验证码",
      desc_bull_board_enabled: "在 /admin/queues 开放后台任务队列管理界面",
      desc_customer_push_enabled: "为顾客端启用推送通知",
    },
    legalContent: {
      languageLabel: "语言",
      languageHint: "● 表示这种语言已经写好。顾客看哪种语言，就显示哪种；没写的语言会改显示 English 版本。",
      title: "法律内容",
      subtitle: "编辑各应用中显示的使用条款/隐私政策。修改仅立即应用于对应的应用。",
      applicationLabel: "应用",
      documentLabel: "文件类型",
      editorTitle: "文件编辑",
      previewSubtitle: "顾客端显示预览",
      saveHint: "更改仅应用于当前选择的应用。",
      appAdmin: "管理后台",
      appPos: "POS 收银应用",
      appStall: "档口应用",
      appCustomer: "顾客端应用",
      docTerms: "使用条款",
      docPrivacy: "隐私政策",
      titleLabel: "标题",
      contentLabel: "内容（支持 Markdown：# 标题、## 子标题、**加粗**、- 列表项）",
      preview: "预览",
      save: "保存",
      saveSuccess: "已保存",
      saveFailed: "保存失败，请重试",
      lastUpdated: "最后更新于 {{date}}",
      neverUpdated: "尚未配置 —— 目前向用户显示占位文本",
      unsavedContentHint: "内容为空时将向用户显示占位文本",
    },
    pricingRules: {
      title: "定价规则",
      subtitle: "仅适用于客户端订单（外卖及自取）的单品加价规则。POS 堂食订单始终使用原始菜单价格。",
      configurationTitle: "价格配置",
      configurationSubtitle: "设置基础餐品与付费加料向顾客显示的加价规则。",
      exampleSubtitle: "编辑规则时，下方金额会即时更新。此处设置为单边值：顾客看到的价格加 2 倍（0.50 / 3.5% → 加 RM1.00 / 7%），档口被扣 1 倍（RM0.50 / 3.5%）。加价后的价格一律向上取整到 10 仙；套餐按套餐最终价格统一套用同一规则（≤ 阈值加固定手续费，否则按百分比）。",
      saveHint: "保存后更改才会生效。",
      thresholdLabel: "价格阈值（RM）",
      thresholdHint: "价格低于或等于此金额的商品加收固定手续费，高于此金额的商品则改为按百分比加收。",
      flatFeeLabel: "≤ 阈值商品的固定手续费（RM）",
      percentLabel: "> 阈值商品的加价百分比（%）",
      exampleTitle: "实时示例",
      exampleLow: "RM {{price}} 的商品 → 顾客看到 RM {{result}}（≤ 阈值，固定手续费）",
      exampleHigh: "RM {{price}} 的商品 → 顾客看到 RM {{result}}（> 阈值，加价 {{percent}}%）",
      exampleAddon: "RM {{price}} 的加料 → 顾客看到 RM {{result}}（加料加价 {{percent}}%，始终适用）",
      exampleStallNet: "档口预计营收 RM {{net}}（被扣 RM {{fee}}；平台合计收入 RM {{platform}}）",
      addonSectionTitle: "加料加价率",
      addonSectionSub: "无论上方基础商品价格走哪一档，每个付费加料都会按其自身价格单独计算此加价率，与基础商品规则相互独立。",
      addonPercentLabel: "加料加价（%）",
      saveSuccess: "定价规则已保存",
      saveFailed: "保存定价规则失败",
    },
    // Hours
    hours: {
      title: "营业时间与节假日",
      subtitle: "管理每周营业时间与特殊休息日期。",
      cardOperatingHours: "营业时间",
      saveHours: "保存时间",
      cardHolidays: "节假日 / 休息日",
      colDate: "日期",
      colNote: "备注",
      addHolidayBtn: "添加",
      datePickerPlaceholder: "选择日期",
      notePlaceholder: "备注（选填）",
      dateRequired: "请选择日期",
      confirmRemoveHoliday: "确认删除此节假日？",
      open: "营业",
      closed: "休息",
      saveSuccess: "营业时间已保存",
      saveFailed: "保存失败",
      updateHolidaySuccess: "节假日已更新",
      updateHolidayFailed: "更新节假日失败",
      holidayAdded: "节假日已添加",
      holidayAddFailed: "添加失败",
      days: {
        sunday: "星期日",
        monday: "星期一",
        tuesday: "星期二",
        wednesday: "星期三",
        thursday: "星期四",
        friday: "星期五",
        saturday: "星期六",
      },
    },
    // Settings
    settings: {
      title: "系统设置",
      sectionBusiness: "商家信息",
      sectionTax: "税费设置",
      fieldKopitiamName: "茶室名称",
      fieldAddress: "地址",
      fieldPhone: "联系电话",
      fieldSstRate: "SST税率 (%)",
      fieldSstTooltip: "请填写百分比，例如 6 表示 6%",
      fieldDeliveryFee: "默认外卖费 (RM)",
      fieldDeliveryFeeTooltip: "向顾客收取的固定外卖费",
      saveBtn: "保存设置",
      saveSuccess: "设置已保存",
      saveFailed: "保存失败",
      addBtn: "添加",
    },
    settingsScreen: {
      coordsMissingBanner: "⚠️ 茶室（门店）还没有设置坐标（经纬度）：配送距离会记成 0、配送范围限制不生效，Lalamove 也会用占位位置报价。所有档口共用这一个位置，请到系统设置填写茶室地址并查找坐标。",
      coordsMissingAction: "去设置",
      findByAddress: "根据地址查找坐标",
      geoNeedAddress: "请先填写店铺地址",
      geoFound: "已根据地址找到坐标，请核对地图位置后点“保存”。",
      geoApprox: "⚠️ 这只是地址附近的大概位置，不是店铺的准确位置！请到 Google Maps 搜店名，右键店铺位置复制经纬度，粘贴到下方“粘贴 Google Maps 坐标”再保存。",
      pasteCoordsPh: "粘贴 Google Maps 坐标，例如 3.0123, 101.6123",
      pasteCoordsHint: "最准确的方法：Google Maps 搜店名 → 右键店铺位置 → 点第一行坐标复制 → 粘贴到这里。",
      pasteCoordsBad: "格式不对，应类似 3.0123, 101.6123（纬度, 经度）",
      gKeyTitle: "Google Maps API Key（可选）",
      gKeyOn: "已设置（末 4 位 {{last4}}）。查找坐标只有近似结果时，会自动再用 Google 查一次。",
      gKeyOff: "未设置。设置后，查找坐标只有近似结果时会自动再用 Google 查一次（更准确）。",
      gKeyPh: "粘贴 Google Geocoding API Key",
      gKeySave: "保存 Key",
      gKeyReplace: "替换 Key",
      gKeyRemove: "移除",
      gKeySaved: "已保存",
      gKeyFailed: "保存失败，请重试",
      geoNone: "找不到这个地址的坐标：请检查地址（可只写“邮编 城市, 州”），或手动输入经纬度。",
      geoOpenMap: "在地图上查看",
      geoSaveHint: "确认无误后别忘了点右上角“保存”。",
      sstRateInvalid: "SST 税率必填，且必须在 0% 到 100% 之间（不收 SST 请填 0）",
      payMethodsMovedHint: "现金、电子钱包、银行卡、FPX 的线上结账开关（含各支付方式的网关凭证）请到「支付方式」页面设置。",
      otherProvidersHint: "Lalamove、GrabExpress 等配送服务商（含沙盒/正式环境凭证与连接测试）请到「配送服务商」页面设置。",
      logoUpdated: "Logo 已更新",
      logoUpdateFailed: "Logo 保存失败",
      baseFeeInvalid: "默认外送费必填，且不能是负数",
      sstRateRequired: "SST 税率必填（不收 SST 请填 0）",
      sstRateRange: "SST 税率必须在 0 到 100 之间",
      baseFeeRequired: "默认外送费必填",
      baseFeeNotNumber: "外送费不能是负数或非数字",
      baseFeeTooHigh: "外送费不能超过 RM 200",
      lblAppVersion: "应用版本标签",
      appVersionHint: "显示在顾客端个人资料页和 POS 登录页底部。",
      goToDeliveryProviders: "管理配送服务商",
      goToPaymentMethods: "管理支付方式",
      title: "系统设置",
      subtitle: "集中管理门店营运、顾客渠道与系统偏好。",
      saveChanges: "保存更改",
      saveSuccess: "设置已保存",
      saveFailed: "保存失败，请重试。",
      storeNameRequired: "请填写门店名称",
      tabStore: "门店信息",
      tabDelivery: "外送",
      tabTax: "税务与货币",
      tabPayment: "支付",
      tabPrinter: "打印机",
      tabNotifications: "通知",
      tabSms: "短信模板",
      smsTemplatesTitle: "OTP 短信模板",
      smsTemplatesExtra: "顾客登录时收到的短信内容",
      lblSmsDefaultLang: "默认发送语言",
      smsDefaultLangHint: "下面哪个模板会真正用来发送验证码——随时可以改，不用改代码。",
      langChinese: "中文",
      lblSmsTemplateZh: "中文模板",
      lblSmsTemplateEn: "英文模板",
      lblSmsTemplateMs: "马来文模板",
      defaultBadge: "默认",
      smsTemplateHint: "用 {code} 代表验证码，{minutes} 代表有效分钟数。某个语言留空的话会用占位符里显示的内置模板。",
      smsPreviewTitle: "预览",
      smsPreviewHint: "这就是顾客今天实际收到的内容，用了一个示例验证码。",
      otpLimitsTitle: "验证码发送限制",
      otpLimitsExtra: "同时适用于短信和邮件验证码。",
      lblOtpDailyCap: "每日最多发送次数",
      lblOtpCooldownSeconds: "发送间隔冷却时间（秒）",
      lblOtpExpirySeconds: "验证码有效期（秒）",
      lblOtpCodeLength: "验证码位数",
      tabRegistration: "注册设置",
      registrationTitle: "顾客注册",
      registrationExtra: "控制新顾客可以使用哪些渠道注册。",
      allowEmailRegistration: "允许邮箱注册",
      allowEmailRegistrationDesc: "允许新顾客使用邮箱地址注册。",
      allowPhoneRegistration: "允许手机注册",
      allowPhoneRegistrationDesc: "允许新顾客使用手机号码注册。",
      tabEmail: "邮件",
      emailTitle: "邮件发送设置",
      emailExtra: "配置 Resend 或 SMTP，让注册和重置密码验证码可以通过邮件发送。",
      emailEnabled: "启用邮件发送",
      emailEnabledDesc: "关闭时验证码只会记录到日志，不会真正发送 — 在还没有正式凭证前可用此模式。",
      emailProvider: "发送方式",
      emailProviderSmtp: "SMTP（例如 Gmail）",
      resendApiKey: "RESEND API KEY",
      emailFromAddress: "发件邮箱地址",
      smtpHost: "SMTP 主机",
      smtpPort: "端口",
      smtpSecure: "使用 SSL（端口 465）",
      smtpUser: "SMTP 账号",
      smtpPass: "SMTP 密码",
      smtpPassPlaceholder: "Gmail 请使用应用专用密码（App Password），不是登录密码",
      emailTemplatesTitle: "邮件模板",
      emailTemplatesExtra: "按语言自定义验证码邮件内容。",
      lblEmailTemplateDefaultLang: "默认语言",
      emailTemplateHint: "发送验证码邮件时使用此语言。",
      lblEmailTemplateSubject: "邮件主题",
      lblEmailTemplateHeading: "标题",
      lblEmailTemplateIntro: "开头文字",
      lblEmailTemplateOutro: "结尾文字",
      emailTemplatePlaceholderHint: "使用 {code} 代表验证码，{minutes} 代表有效分钟数。留空则使用内置默认文案。",
      sectionBasicInfo: "基本信息",
      lblStoreName: "门店名称",
      lblPhone: "电话",
      lblEmail: "邮箱",
      lblAddress: "地址",
      lblLatitude: "纬度",
      lblLongitude: "经度",
      useCurrentLocation: "使用当前位置",
      locationHint: "本美食广场的真实取货坐标 — 作为配送报价的起点，让 Lalamove 运费和调度反映真实距离，而非占位坐标。",
      geolocationUnsupported: "此浏览器不支持定位",
      geolocationFailed: "无法获取您的位置",
      phPhone: "03-1234 5678",
      phEmail: "hello@kopitiam.com",
      sectionOrderTypes: "接受的订单类型",
      allowPickupTitle: "允许自取订单",
      allowPickupDesc: "顾客可线上下单、到店取餐",
      allowDeliveryTitle: "允许外送订单",
      allowDeliveryDesc: "启用自营骑手或第三方外送",
      sectionBranding: "门店品牌",
      brandLogoTitle: "品牌 Logo",
      brandLogoHint: "支持 PNG、JPG（最大 2MB），建议 512×512 像素。",
      uploadLogo: "上传新 Logo",
      sectionHours: "营业时间",
      applyAllDays: "✓ 应用到每日",
      open: "营业",
      closed: "休息",
      holidayHintBefore: "假日歇业可在",
      holidayHintLink: "特殊日期",
      holidayHintAfter: "中管理。",
      sectionDeliveryFee: "外送费",
      lblBaseFee: "起步价",
      hintBaseFee: "任意外送的固定起步费用",
      lblFeePerKm: "每公里加价",
      hintFeePerKm: "按行驶公里加收",
      lblMinFee: "最低收费",
      hintMinFee: "外送费下限",
      lblMaxFee: "最高封顶",
      hintMaxFee: "外送费上限",
      lblMarkupPct: "加价比例 %",
      hintMarkupPct: "在计算费用基础上按比例加收",
      feePreview: "费用预览",
      dynamicEstimate: "动态估算",
      kmUnit: "{{n}} 公里",
      outOfRange: "超出范围",
      sectionDeliveryRadius: "外送范围",
      lblMaxRadius: "最大外送半径",
      hintRadius: "超出范围的订单将被拒绝",
      kmSuffix: "公里",
      saveFailedRadiusExceeded: "最大外送半径不能超过 {{max}} 公里",
      sectionRiderAssignment: "骑手分配",
      readOnly: "只读",
      lblMethod: "方式",
      riderMethodManual: "手动（管理员指派骑手）",
      riderGpsNote:
        "本系统为手动指派骑手，内部骑手不提供 GPS 追踪。",
      thirdPartyTitle: "第三方物流对接",
      thirdPartySubtitle: "连接物流商以自动派单。",
      providerNone: "无（手动）",
      providerLalamove: "Lalamove",
      providerGrabExpress: "GrabExpress",
      connected: "已连接",
      setupRequired: "待配置",
      lblApiKey: "API 密钥",
      lastVerified: "上次验证：今日 9:00",
      disconnect: "断开",
      editCredentials: "编辑凭据",
      lblClientId: "客户端 ID",
      phEnterId: "请输入 ID",
      lblClientSecret: "客户端密钥",
      lblCountry: "国家/地区",
      countryMalaysia: "马来西亚",
      lblEnvironment: "环境",
      envSandbox: "沙箱",
      envProduction: "生产",
      testConnection: "测试连接",
      sstConfigTitle: "SST 配置",
      sstConfigSubtitle: "全局 SST：档口没有单独设定时使用；套餐一律使用它。SST 已包含在顾客看到的价格里，购物车和结账不再另列 SST，每笔订单会逐项保存当时的税率与税额。",
      chargeSstLabel: "对订单收取 SST",
      lblSstRate: "SST 税率 %",
      calcFormula: "计算公式",
      calcFormulaBody: "顾客价格 = 加价后价格 × (1 + SST%)，向上取整到 10 sen",
      exampleLabel: "示例：",
      exampleBody: "RM 10.00 × (1 + {{rate}}%) 向上取整 =",
      currencyTitle: "货币显示",
      currencySubtitle: "POS 与终端的金额展示方式。",
      lblCurrency: "货币",
      currencyReadonly: "MYR — 马来西亚令吉",
      lblDisplayFormat: "显示格式",
      displayFormatSample: "RM 12.50",
      lblStorageFormat: "存储格式",
      storageFormatSample: "整数（分）例如 1250",
      currencyLockedNote: "货币设置已锁定，请联系支持修改。",
      taxHelpTitle: "需要税务法规帮助？",
      taxHelpSubtitle: "查看马来西亚皇家关税局最新 SST 指南。",
      learnMore: "了解更多",
      payMethodsTitle: "支付方式",
      payMethodsSubtitle: "配置顾客如何付款。",
      payMinOneHint: "至少需要启用一种支付方式。",
      transactionSettingsTitle: "交易设置",
      txnRecordedLabel: "已记录交易",
      txnRecordedDesc: "仅在支付成功后记录",
      failedPayLabel: "失败支付",
      failedPayDesc: "不会存入系统",
      cashRefundTitle: "现金退款",
      cashRefundDesc: "允许在收银台处理现金退款",
      bankRefundTitle: "银行转账退款",
      bankRefundDesc: "启用银行退款流程",
      refundsManualNote: "退款由管理员人工处理。",
      payCashName: "现金",
      payCashDesc: "顾客当面付款",
      payDuitnowName: "DuitNow 二维码",
      payDuitnowDesc: "扫码即时银行转账",
      payFpxName: "网银 (FPX)",
      payFpxDesc: "直连银行转账",
      payCardName: "信用卡 / 借记卡",
      payCardDesc: "Visa、Mastercard",
      payGrabpayName: "GrabPay",
      payGrabpayDesc: "GrabPay 电子钱包",
      payTngName: "Touch 'n Go eWallet",
      payTngDesc: "TNG 电子钱包支付",
      printerSetup: "打印机设置",
      testPrint: "测试打印",
      lblPrinterName: "打印机名称",
      printerNameDefault: "主厨房打印机",
      lblConnType: "连接方式",
      connNetwork: "网络",
      connUsb: "USB",
      connBluetooth: "蓝牙",
      lblIpAddress: "IP 地址",
      lblPaperWidth: "纸宽",
      autoPrintTitle: "自动打印",
      autoKitchenName: "接单时打印厨房单",
      autoKitchenDesc: "自动发往厨房打印机",
      autoReceiptName: "完成订单时打印小票",
      autoReceiptDesc: "完成时打印顾客小票",
      manualPrintName: "仅手动触发打印",
      manualPrintDesc: "员工在订单详情手动打印",
      kitchenSlipTitle: "厨房单内容",
      kitchenOrderId: "订单号",
      kitchenOrderType: "订单类型",
      kitchenCustomerName: "顾客姓名",
      kitchenItems: "品项与定制",
      kitchenSpecial: "特殊说明",
      kitchenEstTime: "预计时间",
      receiptContentTitle: "小票内容",
      receiptStoreAddr: "店名与地址",
      receiptOrderDate: "订单号与日期",
      receiptItemsPrices: "品项与价格",
      receiptSubtotal: "小计、外送费、SST、折扣",
      receiptTotal: "合计金额",
      receiptPayMethod: "支付方式",
      livePreviewTitle: "小票实时预览",
      livePreviewSubtitle: "厨房单与小票内容变更将反映在管理端。",
      previewStoreName: "茶室总店",
      previewStoreAddr: "吉隆坡某某街 123 号",
      previewItem1: "1× 冰茶 O",
      previewItem1Note: "- 无糖",
      previewItem2: "1× 咖椰吐司",
      previewTotal: "合计",
      previewThankYou: "感谢惠顾！",
      previewPrice1: "RM 3.50",
      previewPrice2: "RM 4.80",
      previewTotalAmount: "RM 8.30",
      demoMaskedApiKey: "sk_live_*******a2f",
      orderAlertsTitle: "订单提醒",
      orderAlertsExtra: "配置实时门店动态的提醒方式。",
      alertNewOrder: "新订单",
      alertCancelled: "订单自动取消",
      alertRider: "已分配外送骑手",
      alertDelayed: "订单延迟",
      tagSoundAlert: "声音提醒",
      tagTabletPush: "平板推送",
      stallNotifTitle: "档口通知",
      stallNotifDesc:
        "接单后各档口设备仅收到与本档口相关的品项推送。",
      flowAccepted: "订单已接",
      flowFilters: "系统按档口筛选品项",
      flowEachNotified: "各档口仅收到自己的品项通知",
      stallSampleNasi: "椰浆饭档",
      stallSampleDrinks: "饮料档",
      stallSampleWok: "炒锅档",
      stallSampleMamak: "嘛嘛档",
      stallDevice1: "Ali 的 iPhone",
      stallDevice2: "Nurul 的三星",
      stallDevice4: "Rajan 的 iPhone 12",
      stallInfo1: "iOS 17 · 今日在线",
      stallInfo2: "Android 14 · 今日在线",
      stallInfo4: "iOS 16 · 两天前在线",
      notLinked: "未绑定",
      pairingCode: "KP-7F2A",
      enableAllStallsTitle: "启用全部档口通知",
      enableAllStallsDesc: "全局开关各档口提醒。",
      lblNotifLang: "通知语言",
      langEnglish: "English",
      langMalay: "Bahasa Melayu",
      alertSoundTitle: "提醒音效",
      lblVolume: "音量",
      lblSoundTheme: "音效主题",
      soundChime: "铃声",
      soundBell: "钟声",
      soundDing: "叮声",
      previewSound: "试听",
      channelsTitle: "渠道",
      tabletPushTitle: "平板推送",
      tabletPushDesc: "向所有在线商户平板弹出提醒。",
      soundAlertChannelTitle: "声音提醒",
      soundAlertChannelDesc: "收到通知时播放所选音效。",
      smsEmailUnavailable: "当前版本不支持短信与邮件通知。",
      newOrderAlertBanner: "新订单提醒",
      previewBadge: "预览",
      previewOrderTitle: "订单 #1042 — 椰浆饭档",
      previewOrderItems: "椰浆饭炸鸡 x2，椰浆饭鱼 x1",
    },
    stalls: {
      title: "档口管理",
      pageSubtitle: "管理档口资料、营业状态与顾客端显示顺序",
      statTotal: "档口总数",
      statOpen: "营业中",
      statPaused: "已暂停",
      statBadgeOverall: "汇总",
      statBadgeOpen: "营业",
      statBadgePaused: "暂停",
      drawerSubtitleNew: "填写档口资料与营业设置",
      addStall: "添加档口",
      editTitle: "编辑档口",
      basicInfo: "基本信息",
      status: "状态",
      stallStatus: "档口状态",
      stallStatusHint: "暂停后，该档口下所有商品将不可售",
      displayOrder: "显示顺序",
      displayOrderHint: "数值越小，在顾客端越靠前",
      openingHours: "营业时间",
      weekdaysHours: "周一至周五",
      weekendHours: "周六至周日",
      stallName: "档口名称",
      stallNameRequired: "请填写档口名称",
      stallNamePlaceholder: "例如：饮品档",
      description: "简介",
      descriptionPlaceholder: "档口简介",
      discard: "放弃",
      createStall: "创建档口",
      createSuccess: "档口已创建",
      createFailed: "创建档口失败",
      updateSuccess: "档口已更新",
      saveFailed: "保存档口失败",
      opened: "档口已开启",
      closed: "档口已暂停",
      colCover: "封面",
      colName: "名称",
      colDescription: "简介",
      colSortOrder: "排序",
      colSst: "SST",
      colOpen: "营业",
      colActions: "操作",
      tooltipEdit: "编辑档口",
      tooltipDelete: "删除档口",
      deleteConfirm: "确定删除此档口？其菜单将在所有应用中隐藏。",
      deleteSuccess: "档口已删除",
      deleteFailed: "删除档口失败",
      formName: "名称",
      formDescription: "简介",
      formCoverImage: "档口封面",
      formSortOrder: "排序",
      formIsOpen: "接受下单",
      formSst: "SST 税率 %",
      formSstHint: "留空 = 跟随全局 SST；填 0 = 此档口不收 SST。税款已包含在顾客看到的菜品价格里，只对新订单生效，旧订单保留当时的税率。",
      sstFollowGlobal: "跟随全局",
      coverUrlPlaceholder: "https://…",
      hoursWeekdayExample: "08:00 – 22:00",
      hoursWeekendExample: "09:00 – 23:00",
    },
    banners: {
      title: "促销横幅",
      pageSubtitle: "管理促销内容、展示顺序与启用状态",
      statTotal: "横幅总数",
      statActive: "已启用",
      statInactive: "已停用",
      statBadgeOverall: "全部横幅",
      statBadgeActive: "正在展示",
      statBadgeInactive: "暂停展示",
      add: "添加横幅",
      editTitle: "编辑横幅",
      createTitle: "新建横幅",
      colOrder: "排序",
      colTag: "标签",
      colTitle: "标题",
      colPreview: "预览",
      colActive: "启用",
      colActions: "操作",
      sectionContent: "横幅内容",
      sectionAppearance: "图片与外观",
      sectionPublishing: "排序与发布",
      updateSuccess: "横幅已更新",
      createSuccess: "横幅已创建",
      saveFailed: "保存横幅失败",
      deleteConfirm: "确定删除此横幅？",
      deleteSuccess: "横幅已删除",
      deleteFailed: "删除失败",
      fieldTitle: "标题",
      titleRequired: "请填写标题",
      titlePlaceholder: "例如：开斋节特惠",
      fieldTag: "标签文字",
      tagRequired: "请填写标签",
      tagPlaceholder: "例如：促销",
      fieldTagColor: "标签颜色",
      fieldImageUrl: "横幅图片",
      fieldOrder: "排序",
      fieldActive: "启用",
      preview: "预览",
      previewImageAlt: "横幅预览图",
    },
    paymentMethods: {
      title: "支付方式管理",
      subtitle: "配置支付网关及API凭证",
      statTotal: "支付方式总数",
      statActive: "已启用",
      statInactive: "已停用",
      statSandbox: "测试环境",
      statBadgeOverall: "汇总",
      statBadgeActive: "启用",
      statBadgeInactive: "停用",
      statBadgeSandbox: "测试",
      addMethod: "添加支付方式",
      editTitle: "编辑支付方式",
      newTitle: "新增支付方式",
      colProvider: "支付网关",
      colMethod: "支付类型",
      colDisplayName: "显示名称",
      colApiKey: "API密钥",
      colQrCode: "二维码",
      colStatus: "启用",
      colActions: "操作",
      sectionGeneral: "基本资料",
      sectionCredentials: "网关凭证",
      sectionDisplay: "显示与状态",
      formProvider: "支付网关",
      formMethod: "支付类型",
      formDisplayName: "显示名称",
      formApiKey: "API密钥",
      formApiKeyPlaceholder: "输入API密钥（加密存储）",
      formApiSecret: "API密钥Secret",
      formApiSecretPlaceholder: "输入API密钥Secret",
      formCollectionId: "Collection ID（Billplz）/ Profile ID（Hyperswitch）",
      formMerchantId: "商户 ID（Fiuu）",
      phMerchantId: "例如：Fiuu 商户 ID",
      formWebhookSecret: "Webhook密钥",
      formWebhookSecretPlaceholder: "输入Webhook验证密钥",
      formQrImageUrl: "二维码图片链接",
      formSortOrder: "排序",
      formIsActive: "启用",
      testConnection: "测试连接",
      confirmDelete: "确定删除此支付方式配置？",
      createSuccess: "支付方式已添加",
      updateSuccess: "支付方式已更新",
      deleteSuccess: "支付方式已删除",
      saveFailed: "保存失败",
      deleteFailed: "删除失败",
      testFailed: "连接测试失败",
      phSelectProvider: "选择网关",
      phSelectMethod: "选择支付类型",
      phDisplayName: "例如：Billplz FPX、现金",
      phCollectionId: "例如：Billplz Collection ID 或 Hyperswitch Profile ID",
      phQrUrl: "https://…（二维码图片 URL）",
      colQrBadge: "二维码",
      qrPreviewAlt: "二维码预览",
      providerBillplz: "Billplz（FPX/卡）",
      providerToyyibpay: "ToyyibPay",
      providerStripe: "Stripe",
      providerManual: "人工 / 现金",
      providerQrStatic: "静态二维码",
      providerGrabpay: "GrabPay 直连",
      providerBoost: "Boost",
      providerTng: "Touch 'n Go 电子钱包",
      providerHyperswitch: "Hyperswitch",
      providerFiuu: "Fiuu（雷诺商户服务）",
      providerCustom: "自定义网关",
      methodFpx: "FPX",
      methodVisa: "Visa / MasterCard",
      methodGrabpay: "GrabPay",
      methodCash: "现金",
      methodEwallet: "电子钱包",
      methodTng: "Touch 'n Go",
      methodBoost: "Boost",
      methodQr: "二维码（静态）",
    },
    deliveryProviders: {
      formSandboxMode: "测试模式",
      sandbox: "测试环境",
      production: "正式环境",
      sandboxModeHint: "测试模式使用服务商的测试环境。配置正式环境凭证后再关闭。",
      title: "配送服务商管理",
      subtitle: "配置配送API及覆盖范围设置",
      statTotal: "服务商总数",
      statActive: "已启用",
      statInactive: "已停用",
      statSandbox: "测试环境",
      statBadgeOverall: "全部配置",
      statBadgeActive: "正在使用",
      statBadgeInactive: "暂停使用",
      statBadgeSandbox: "测试配置",
      addProvider: "添加配送服务商",
      editTitle: "编辑配送服务商",
      newTitle: "新增配送服务商",
      colProvider: "配送平台",
      colDisplayName: "名称",
      colApiKey: "API密钥",
      colBaseUrl: "API地址",
      colCoverage: "覆盖范围",
      colStatus: "启用",
      colActions: "操作",
      sectionGeneral: "基本资料",
      sectionCredentials: "API 与凭证",
      sectionOperations: "服务设置",
      formProvider: "配送平台",
      formDisplayName: "显示名称",
      formApiKey: "API密钥",
      formApiKeyPlaceholder: "输入API密钥",
      formApiSecret: "API密钥Secret",
      formApiSecretPlaceholder: "输入API密钥Secret",
      formWebhookSecret: "Webhook密钥",
      formWebhookSecretPlaceholder: "输入Webhook密钥",
      formBaseUrl: "API基础URL",
      formCoverageKm: "覆盖半径",
      formSortOrder: "排序",
      formIsActive: "启用",
      testConnection: "测试API连接",
      confirmDelete: "确定删除此配送服务商？",
      createSuccess: "配送服务商已添加",
      updateSuccess: "配送服务商已更新",
      deleteSuccess: "配送服务商已移除",
      saveFailed: "保存失败",
      deleteFailed: "删除失败",
      testFailed: "API测试失败",
      phSelectProvider: "选择平台",
      phDisplayName: "例如：Lalamove 当日达",
      phBaseUrl: "https://rest.lalamove.com",
      unitKm: "公里",
      coverageKm: "{{km}} 公里",
      providerLalamove: "Lalamove",
      providerGrabexpress: "GrabExpress",
      providerFoodpanda: "Foodpanda 配送",
      providerPandago: "PandaGo",
      providerMyposrider: "MyPOS Rider",
      providerManual: "人工（店内）",
      providerCustom: "自定义 API",
    },
    smsProviders: {
      title: "短信服务商管理",
      subtitle: "配置短信/验证码API集成及故障转移优先级",
      statTotal: "服务商总数",
      statActive: "已启用",
      statHealthy: "连接正常",
      statInactive: "已停用",
      statBadgeOverall: "全部配置",
      statBadgeActive: "正在使用",
      statBadgeHealthy: "状态正常",
      statBadgeInactive: "暂停使用",
      addProvider: "添加短信服务商",
      editTitle: "编辑短信服务商",
      newTitle: "新增短信服务商",
      colProvider: "服务商",
      colDisplayName: "名称",
      colSortOrder: "优先级",
      colHealthy: "健康状态",
      colStatus: "启用",
      colActions: "操作",
      sectionGeneral: "基本资料",
      sectionCredentials: "API 与凭证",
      sectionOperations: "服务设置",
      healthy: "健康",
      unhealthy: "异常",
      formProvider: "短信服务商",
      formDisplayName: "显示名称",
      formApiKey: "API密钥",
      formApiKeyPlaceholder: "输入API密钥",
      formApiSecret: "API密钥Secret",
      formApiSecretPlaceholder: "输入API密钥Secret",
      formWebhookSecret: "Webhook密钥",
      formWebhookSecretPlaceholder: "输入Webhook密钥",
      formAccountSid: "Account SID",
      formAccountSidPlaceholder: "输入 Account SID",
      formAuthToken: "Auth Token",
      formAuthTokenPlaceholder: "输入 Auth Token",
      formMessagingServiceSid: "Messaging Service SID（可选）",
      formMessagingServiceSidHint: "只有用 Messaging Service 发送（而不是单一号码）时才需要填。",
      formMessagingServiceSidPlaceholder: "输入 Messaging Service SID",
      formSms123Email: "sms123.net 账号邮箱",
      formSms123EmailHint: "你注册 sms123.net 账号用的邮箱——提交模板审批时需要用到。",
      formSms123EmailPlaceholder: "例如：you@company.com",
      submitTemplateTooltip: "提交模板审批",
      submitTemplateTitle: "提交模板到 sms123.net",
      submitTemplateOk: "提交",
      submitTemplateHint: "这里只是提交申请——审批结果（通过/拒绝）会由 sms123.net 发到他们自己配置的回调地址，我们这边拿不到，请到 sms123.net 后台自行查看结果。",
      templateTitleLabel: "模板标题",
      templateTitlePlaceholder: "例如：OTP 验证码",
      templateContentLabel: "短信内容",
      templateContentHint: "这里用的是 sms123.net 自己的占位符语法（%%），不是我们系统设置 > 短信模板里的 {code}/{minutes}（那个是我们自己发送前替换的，sms123.net 从来看不到）。开头要带价格声明前缀和公司名，例如 \"RM0 公司名 : ...\"——这条格式是 sms123.net 客服直接告知的，不在他们公开文档里。",
      templateContentPlaceholder: "例如：RM0 KawKaw : Your verification code is %%. It expires in %% minutes.",
      templateSubmitFailed: "提交模板失败",
      formBaseUrl: "API基础URL",
      formConfigJson: "配置（JSON）",
      formSortOrder: "故障转移优先级",
      formIsActive: "启用",
      sortOrderHint: "数字越小，优先尝试",
      configJsonHint: "这就是上面简易表单填的内容，以原始 JSON 显示——只有表单填不了的特殊情况才需要用到这里。随时可以切回简易表单。",
      builtInNote: "{{provider}} 已经预先配置好了，下面只需要填你的账号凭证即可。",
      customConfigTitle: "请求设置",
      customConfigHint: "告诉我们要发什么、怎么读懂返回结果——不用写代码。",
      contentTypeLabel: "数据发送方式",
      contentTypeForm: "表单字段（大部分服务商用这个）",
      contentTypeQuery: "URL 查询参数（GET）—— 例如 sms123.net",
      contentTypeJson: "JSON",
      authStyleLabel: "API Key 怎么传",
      authStyleNone: "作为下面字段之一传递",
      authStyleBearer: "放在 Authorization 请求头",
      bodyFieldsLabel: "要发送的字段",
      fieldNamePlaceholder: "字段名（例如 recipients）",
      customValuePlaceholder: "要发送的固定文字",
      addField: "+ 添加字段",
      value_phone: "手机号码",
      value_message: "短信内容",
      value_apiKey: "API Key",
      value_apiSecret: "API Secret",
      value_referenceId: "唯一请求编号（自动生成）",
      value_custom: "固定文字…",
      advancedErrorHandling: "读取返回结果（可选）",
      advancedErrorHandlingHint: "只有当服务商即使失败也一律返回成功（HTTP 200），真正结果藏在返回内容里时才需要填。",
      successFieldLabel: "成功状态字段名",
      successFieldPlaceholder: "例如：status",
      successValueLabel: "代表成功的值",
      successValuePlaceholder: "例如：ok",
      errorCodeFieldLabel: "错误代码字段名",
      errorCodeFieldPlaceholder: "例如：msgCode",
      permanentCodesLabel: "代表\"号码有问题，不用重试\"的错误代码",
      permanentCodesHint: "用逗号分隔。不确定就留空——无法识别的代码默认当作可重试处理。",
      transientCodesLabel: "代表\"换下一个服务商试试\"的错误代码",
      transientCodesHint: "用逗号分隔，例如余额不足或凭证无效。",
      codesPlaceholder: "例如：E00242, E00250",
      editRawJson: "高级：编辑原始 JSON",
      backToSimpleForm: "← 返回简易表单",
      testConnection: "发送测试短信",
      testPhoneLabel: "测试手机号码",
      testPhoneHint: "留空则只验证凭证（仅限 Twilio，不发送短信，不产生费用）。填号码则会发送一条真实测试短信——sms123/自定义服务商没有免费验证方式，必须填号码。",
      testPhonePlaceholder: "例如：+60123456789",
      sendTest: "发送测试",
      confirmDelete: "确定删除此短信服务商？",
      createSuccess: "短信服务商已添加",
      updateSuccess: "短信服务商已更新",
      deleteSuccess: "短信服务商已移除",
      saveFailed: "保存失败",
      deleteFailed: "删除失败",
      testFailed: "短信测试失败",
      phSelectProvider: "选择服务商",
      phDisplayName: "例如：Twilio 主账号",
      phBaseUrl: "https://api.sms123.example.com/send",
      phConfigJson: '{"content_type":"query","method":"GET","auth_style":"none","body_template":{"apiKey":"{{apiKey}}","recipients":"{{phone}}","messageContent":"{{message}}","referenceID":"{{referenceId}}"},"success_check":{"field":"status","equals":"ok"},"error_code_field":"msgCode","permanent_error_codes":["E00242"],"transient_error_codes":["E00250","E00359"]}',
      providerTwilio: "Twilio",
      providerSms123: "sms123",
      providerCustom: "自定义 API",
    },
    login: {
      termsAndConditions: "服务条款",
      privacyPolicy: "隐私政策",
    },
  },
};
